export const SCENE_ANIMATION_2 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "police1,-2.377,0.000,-5.109,0.000,0.380,0.000,0.925",
                "police2,-2.419,0.000,-5.374,0.000,0.380,0.000,0.925",
                "security,-2.382,0.000,-4.888,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.499,0.380,-3.853,0.024,-0.963,0.091,0.252"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "police1,-2.377,0.000,-5.109,0.000,0.380,0.000,0.925",
                "police2,-2.419,0.000,-5.374,0.000,0.380,0.000,0.925",
                "security,-2.382,0.000,-4.888,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.499,0.380,-3.853,0.024,-0.963,0.091,0.252"
            ]
        },
        {
            "time": 0.0430000014603138,
            "data": [
                "police1,-2.374,0.000,-5.106,0.000,0.380,0.000,0.925",
                "police2,-2.415,0.000,-5.370,0.000,0.380,0.000,0.925",
                "security,-2.379,0.000,-4.885,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.498,0.380,-3.854,0.024,-0.963,0.091,0.253"
            ]
        },
        {
            "time": 0.061000000685453418,
            "data": [
                "police1,-2.368,0.000,-5.100,0.000,0.380,0.000,0.925",
                "police2,-2.407,0.000,-5.362,0.000,0.380,0.000,0.925",
                "security,-2.374,0.000,-4.879,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.497,0.380,-3.854,0.024,-0.963,0.091,0.253"
            ]
        },
        {
            "time": 0.07699999958276749,
            "data": [
                "police1,-2.357,0.000,-5.089,0.000,0.380,0.000,0.925",
                "police2,-2.392,0.000,-5.346,0.000,0.380,0.000,0.925",
                "security,-2.362,0.000,-4.868,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.496,0.380,-3.854,0.024,-0.963,0.091,0.254"
            ]
        },
        {
            "time": 0.07999999821186066,
            "data": [
                "police1,-2.345,0.000,-5.076,0.000,0.380,0.000,0.925",
                "police2,-2.375,0.000,-5.330,0.000,0.380,0.000,0.925",
                "security,-2.350,0.000,-4.856,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.495,0.379,-3.854,0.024,-0.963,0.091,0.254"
            ]
        },
        {
            "time": 0.09399999678134918,
            "data": [
                "police1,-2.342,0.000,-5.074,0.000,0.380,0.000,0.925",
                "police2,-2.372,0.000,-5.326,0.000,0.380,0.000,0.925",
                "security,-2.348,0.000,-4.853,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.495,0.379,-3.855,0.024,-0.963,0.091,0.254"
            ]
        },
        {
            "time": 0.10499999672174454,
            "data": [
                "police1,-2.328,0.000,-5.060,0.000,0.380,0.000,0.925",
                "police2,-2.353,0.000,-5.308,0.000,0.380,0.000,0.925",
                "security,-2.334,0.000,-4.840,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.494,0.379,-3.855,0.024,-0.962,0.091,0.255"
            ]
        },
        {
            "time": 0.11500000208616257,
            "data": [
                "police1,-2.317,0.000,-5.048,0.000,0.380,0.000,0.925",
                "police2,-2.338,0.000,-5.292,0.000,0.380,0.000,0.925",
                "security,-2.323,0.000,-4.828,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.493,0.379,-3.855,0.024,-0.962,0.091,0.255"
            ]
        },
        {
            "time": 0.12700000405311585,
            "data": [
                "police1,-2.305,0.000,-5.036,0.000,0.380,0.000,0.925",
                "police2,-2.321,0.000,-5.275,0.000,0.380,0.000,0.925",
                "security,-2.311,0.000,-4.816,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.493,0.379,-3.855,0.024,-0.962,0.091,0.256"
            ]
        },
        {
            "time": 0.1379999965429306,
            "data": [
                "police1,-2.291,0.000,-5.022,0.000,0.380,0.000,0.925",
                "police2,-2.303,0.000,-5.256,0.000,0.380,0.000,0.925",
                "security,-2.297,0.000,-4.802,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.492,0.379,-3.855,0.024,-0.962,0.091,0.256"
            ]
        },
        {
            "time": 0.15000000596046449,
            "data": [
                "police1,-2.276,0.000,-5.007,0.000,0.380,0.000,0.925",
                "police2,-2.283,0.000,-5.236,0.000,0.380,0.000,0.925",
                "security,-2.283,0.000,-4.788,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.491,0.379,-3.856,0.024,-0.962,0.091,0.256"
            ]
        },
        {
            "time": 0.16200000047683717,
            "data": [
                "police1,-2.260,0.000,-4.991,0.000,0.380,0.000,0.925",
                "police2,-2.261,0.000,-5.214,0.000,0.380,0.000,0.925",
                "security,-2.267,0.000,-4.771,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.491,0.379,-3.856,0.024,-0.962,0.091,0.257"
            ]
        },
        {
            "time": 0.17299999296665193,
            "data": [
                "police1,-2.243,0.000,-4.973,0.000,0.380,0.000,0.925",
                "police2,-2.237,0.000,-5.190,0.000,0.380,0.000,0.925",
                "security,-2.250,0.000,-4.754,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.490,0.379,-3.856,0.024,-0.962,0.092,0.257"
            ]
        },
        {
            "time": 0.18199999630451203,
            "data": [
                "police1,-2.226,0.000,-4.957,0.000,0.380,0.000,0.925",
                "police2,-2.215,0.000,-5.168,0.000,0.380,0.000,0.925",
                "security,-2.234,0.000,-4.738,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.489,0.379,-3.856,0.024,-0.962,0.092,0.257"
            ]
        },
        {
            "time": 0.19300000369548798,
            "data": [
                "police1,-2.212,0.000,-4.942,0.000,0.380,0.000,0.925",
                "police2,-2.196,0.000,-5.148,0.000,0.380,0.000,0.925",
                "security,-2.220,0.000,-4.724,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.489,0.379,-3.856,0.024,-0.962,0.092,0.258"
            ]
        },
        {
            "time": 0.20399999618530274,
            "data": [
                "police1,-2.194,0.000,-4.924,0.000,0.380,0.000,0.925",
                "police2,-2.172,0.000,-5.124,0.000,0.380,0.000,0.925",
                "security,-2.202,0.000,-4.706,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.488,0.379,-3.857,0.025,-0.961,0.092,0.258"
            ]
        },
        {
            "time": 0.2160000056028366,
            "data": [
                "police1,-2.177,0.000,-4.907,0.000,0.380,0.000,0.925",
                "police2,-2.148,0.000,-5.100,0.000,0.380,0.000,0.925",
                "security,-2.185,0.000,-4.689,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.487,0.379,-3.857,0.025,-0.961,0.092,0.259"
            ]
        },
        {
            "time": 0.2280000001192093,
            "data": [
                "police1,-2.159,0.000,-4.888,0.000,0.380,0.000,0.925",
                "police2,-2.124,0.000,-5.076,0.000,0.380,0.000,0.925",
                "security,-2.167,0.000,-4.671,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.487,0.379,-3.857,0.025,-0.961,0.092,0.259"
            ]
        },
        {
            "time": 0.2409999966621399,
            "data": [
                "police1,-2.139,0.000,-4.868,0.000,0.380,0.000,0.925",
                "police2,-2.097,0.000,-5.048,0.000,0.380,0.000,0.925",
                "security,-2.147,0.000,-4.651,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.486,0.379,-3.857,0.025,-0.961,0.092,0.259"
            ]
        },
        {
            "time": 0.25600001215934756,
            "data": [
                "police1,-2.116,0.000,-4.845,0.000,0.380,0.000,0.925",
                "police2,-2.066,0.000,-5.017,0.000,0.380,0.000,0.925",
                "security,-2.125,0.000,-4.629,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.485,0.379,-3.858,0.025,-0.961,0.092,0.260"
            ]
        },
        {
            "time": 0.27000001072883608,
            "data": [
                "police1,-2.092,0.000,-4.821,0.000,0.380,0.000,0.925",
                "police2,-2.034,0.000,-4.984,0.000,0.380,0.000,0.925",
                "security,-2.102,0.000,-4.605,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.484,0.379,-3.858,0.025,-0.961,0.092,0.260"
            ]
        },
        {
            "time": 0.28200000524520876,
            "data": [
                "police1,-2.069,0.000,-4.797,0.000,0.380,0.000,0.925",
                "police2,-2.002,0.000,-4.953,0.000,0.380,0.000,0.925",
                "security,-2.079,0.000,-4.581,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.483,0.379,-3.858,0.025,-0.961,0.092,0.261"
            ]
        },
        {
            "time": 0.2939999997615814,
            "data": [
                "police1,-2.048,0.000,-4.777,0.000,0.380,0.000,0.925",
                "police2,-1.975,0.000,-4.925,0.000,0.380,0.000,0.925",
                "security,-2.059,0.000,-4.561,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.483,0.379,-3.858,0.025,-0.961,0.092,0.261"
            ]
        },
        {
            "time": 0.3059999942779541,
            "data": [
                "police1,-2.029,0.000,-4.758,0.000,0.380,0.000,0.925",
                "police2,-1.949,0.000,-4.899,0.000,0.380,0.000,0.925",
                "security,-2.040,0.000,-4.542,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.482,0.379,-3.859,0.025,-0.960,0.093,0.261"
            ]
        },
        {
            "time": 0.3190000057220459,
            "data": [
                "police1,-2.009,0.000,-4.737,0.000,0.380,0.000,0.925",
                "police2,-1.921,0.000,-4.871,0.000,0.380,0.000,0.925",
                "security,-2.020,0.000,-4.522,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.481,0.379,-3.859,0.025,-0.960,0.093,0.262"
            ]
        },
        {
            "time": 0.3319999873638153,
            "data": [
                "police1,-1.989,0.000,-4.717,0.000,0.380,0.000,0.925",
                "police2,-1.894,0.000,-4.844,0.000,0.380,0.000,0.925",
                "security,-2.000,0.000,-4.502,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.480,0.379,-3.859,0.025,-0.960,0.093,0.262"
            ]
        },
        {
            "time": 0.34599998593330386,
            "data": [
                "police1,-1.969,0.000,-4.696,0.000,0.380,0.000,0.925",
                "police2,-1.867,0.000,-4.816,0.000,0.380,0.000,0.925",
                "security,-1.980,0.000,-4.482,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.479,0.379,-3.859,0.025,-0.960,0.093,0.263"
            ]
        },
        {
            "time": 0.3610000014305115,
            "data": [
                "police1,-1.949,0.000,-4.677,0.000,0.380,0.000,0.925",
                "police2,-1.841,0.000,-4.789,0.000,0.380,0.000,0.925",
                "security,-1.961,0.000,-4.462,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.479,0.379,-3.859,0.025,-0.960,0.093,0.263"
            ]
        },
        {
            "time": 0.37400001287460329,
            "data": [
                "police1,-1.929,0.000,-4.656,0.000,0.380,0.000,0.925",
                "police2,-1.813,0.000,-4.762,0.000,0.380,0.000,0.925",
                "security,-1.941,0.000,-4.442,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.478,0.379,-3.860,0.025,-0.960,0.093,0.264"
            ]
        },
        {
            "time": 0.3869999945163727,
            "data": [
                "police1,-1.911,0.000,-4.638,0.000,0.380,0.000,0.925",
                "police2,-1.789,0.000,-4.737,0.000,0.380,0.000,0.925",
                "security,-1.923,0.000,-4.424,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.477,0.379,-3.860,0.025,-0.960,0.093,0.264"
            ]
        },
        {
            "time": 0.39800000190734866,
            "data": [
                "police1,-1.895,0.000,-4.622,0.000,0.380,0.000,0.925",
                "police2,-1.767,0.000,-4.715,0.000,0.380,0.000,0.925",
                "security,-1.908,0.000,-4.409,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.476,0.379,-3.860,0.025,-0.960,0.093,0.265"
            ]
        },
        {
            "time": 0.41200000047683718,
            "data": [
                "police1,-1.883,0.000,-4.609,0.000,0.380,0.000,0.925",
                "police2,-1.751,0.000,-4.699,0.000,0.380,0.000,0.925",
                "security,-1.896,0.000,-4.396,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.475,0.379,-3.860,0.025,-0.959,0.093,0.265"
            ]
        },
        {
            "time": 0.42399999499320986,
            "data": [
                "police1,-1.869,0.000,-4.595,0.000,0.380,0.000,0.925",
                "police2,-1.732,0.000,-4.680,0.000,0.380,0.000,0.925",
                "security,-1.882,0.000,-4.383,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.475,0.379,-3.861,0.025,-0.959,0.093,0.265"
            ]
        },
        {
            "time": 0.43700000643730166,
            "data": [
                "police1,-1.858,0.000,-4.584,0.000,0.380,0.000,0.925",
                "police2,-1.717,0.000,-4.664,0.000,0.380,0.000,0.925",
                "security,-1.871,0.000,-4.371,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.474,0.379,-3.861,0.025,-0.959,0.093,0.266"
            ]
        },
        {
            "time": 0.44999998807907107,
            "data": [
                "police1,-1.847,0.000,-4.574,0.000,0.380,0.000,0.925",
                "police2,-1.703,0.000,-4.650,0.000,0.380,0.000,0.925",
                "security,-1.861,0.000,-4.361,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.473,0.379,-3.861,0.025,-0.959,0.094,0.266"
            ]
        },
        {
            "time": 0.46299999952316286,
            "data": [
                "police1,-1.839,0.000,-4.565,0.000,0.380,0.000,0.925",
                "police2,-1.691,0.000,-4.639,0.000,0.380,0.000,0.925",
                "security,-1.853,0.000,-4.353,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.472,0.379,-3.861,0.026,-0.959,0.094,0.267"
            ]
        },
        {
            "time": 0.47600001096725466,
            "data": [
                "police1,-1.832,0.000,-4.558,0.000,0.380,0.000,0.925",
                "police2,-1.682,0.000,-4.629,0.000,0.380,0.000,0.925",
                "security,-1.845,0.000,-4.346,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.471,0.379,-3.862,0.026,-0.959,0.094,0.267"
            ]
        },
        {
            "time": 0.4869999885559082,
            "data": [
                "police1,-1.827,0.000,-4.553,0.000,0.380,0.000,0.925",
                "police2,-1.675,0.000,-4.622,0.000,0.380,0.000,0.925",
                "security,-1.841,0.000,-4.341,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.471,0.379,-3.862,0.026,-0.959,0.094,0.268"
            ]
        },
        {
            "time": 0.49799999594688418,
            "data": [
                "police1,-1.824,0.000,-4.550,0.000,0.380,0.000,0.925",
                "police2,-1.671,0.000,-4.618,0.000,0.380,0.000,0.925",
                "security,-1.838,0.000,-4.338,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.470,0.379,-3.862,0.026,-0.959,0.094,0.268"
            ]
        },
        {
            "time": 0.5109999775886536,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.380,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.469,0.379,-3.862,0.026,-0.958,0.094,0.268"
            ]
        },
        {
            "time": 0.5239999890327454,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.380,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.384,0.000,-0.923",
                "observationCamera,-1.469,0.379,-3.863,0.026,-0.958,0.094,0.269"
            ]
        },
        {
            "time": 0.5370000004768372,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.377,0.000,0.926",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.389,0.000,-0.921",
                "observationCamera,-1.468,0.379,-3.863,0.026,-0.958,0.094,0.269"
            ]
        },
        {
            "time": 0.5490000247955322,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.374,0.000,0.928",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.398,0.000,-0.917",
                "observationCamera,-1.467,0.379,-3.863,0.026,-0.958,0.094,0.270"
            ]
        },
        {
            "time": 0.5609999895095825,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.369,0.000,0.929",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.409,0.000,-0.912",
                "observationCamera,-1.466,0.379,-3.863,0.026,-0.958,0.094,0.270"
            ]
        },
        {
            "time": 0.574999988079071,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.363,0.000,0.932",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.424,0.000,-0.906",
                "observationCamera,-1.466,0.379,-3.863,0.026,-0.958,0.094,0.270"
            ]
        },
        {
            "time": 0.5870000123977661,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.355,0.000,0.935",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.443,0.000,-0.897",
                "observationCamera,-1.465,0.379,-3.864,0.026,-0.958,0.095,0.271"
            ]
        },
        {
            "time": 0.5989999771118164,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.346,0.000,0.938",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.463,0.000,-0.887",
                "observationCamera,-1.464,0.379,-3.864,0.026,-0.958,0.095,0.271"
            ]
        },
        {
            "time": 0.609000027179718,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.337,0.000,0.942",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.482,0.000,-0.876",
                "observationCamera,-1.463,0.379,-3.864,0.026,-0.957,0.095,0.272"
            ]
        },
        {
            "time": 0.621999979019165,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.328,0.000,0.945",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.502,0.000,-0.865",
                "observationCamera,-1.463,0.379,-3.864,0.026,-0.957,0.095,0.272"
            ]
        },
        {
            "time": 0.6349999904632568,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.316,0.000,0.949",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.527,0.000,-0.850",
                "observationCamera,-1.462,0.379,-3.865,0.026,-0.957,0.095,0.272"
            ]
        },
        {
            "time": 0.6480000019073486,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.303,0.000,0.953",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.555,0.000,-0.832",
                "observationCamera,-1.461,0.379,-3.865,0.026,-0.957,0.095,0.273"
            ]
        },
        {
            "time": 0.6600000262260437,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.290,0.000,0.957",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.582,0.000,-0.813",
                "observationCamera,-1.460,0.379,-3.865,0.026,-0.957,0.095,0.273"
            ]
        },
        {
            "time": 0.6710000038146973,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.276,0.000,0.961",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.610,0.000,-0.793",
                "observationCamera,-1.459,0.379,-3.865,0.026,-0.957,0.095,0.274"
            ]
        },
        {
            "time": 0.6840000152587891,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.262,0.000,0.965",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.636,0.000,-0.772",
                "observationCamera,-1.459,0.379,-3.866,0.026,-0.957,0.095,0.274"
            ]
        },
        {
            "time": 0.6959999799728394,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.247,0.000,0.969",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.665,0.000,-0.747",
                "observationCamera,-1.458,0.379,-3.866,0.026,-0.957,0.095,0.274"
            ]
        },
        {
            "time": 0.7080000042915344,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.231,0.000,0.973",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.693,0.000,-0.721",
                "observationCamera,-1.457,0.379,-3.866,0.026,-0.956,0.095,0.275"
            ]
        },
        {
            "time": 0.7179999947547913,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.216,0.000,0.976",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.719,0.000,-0.695",
                "observationCamera,-1.457,0.378,-3.866,0.027,-0.956,0.095,0.275"
            ]
        },
        {
            "time": 0.7310000061988831,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.203,0.000,0.979",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.741,0.000,-0.671",
                "observationCamera,-1.456,0.378,-3.866,0.027,-0.956,0.096,0.276"
            ]
        },
        {
            "time": 0.7440000176429749,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.186,0.000,0.983",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.769,0.000,-0.640",
                "observationCamera,-1.455,0.378,-3.867,0.027,-0.956,0.096,0.276"
            ]
        },
        {
            "time": 0.7570000290870667,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.168,0.000,0.986",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.795,0.000,-0.607",
                "observationCamera,-1.454,0.378,-3.867,0.027,-0.956,0.096,0.276"
            ]
        },
        {
            "time": 0.7689999938011169,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.151,0.000,0.989",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.820,0.000,-0.573",
                "observationCamera,-1.454,0.378,-3.867,0.027,-0.956,0.096,0.277"
            ]
        },
        {
            "time": 0.781000018119812,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.135,0.000,0.991",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.841,0.000,-0.541",
                "observationCamera,-1.453,0.378,-3.867,0.027,-0.956,0.096,0.277"
            ]
        },
        {
            "time": 0.7929999828338623,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.119,0.000,0.993",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.861,0.000,-0.508",
                "observationCamera,-1.452,0.378,-3.868,0.027,-0.956,0.096,0.278"
            ]
        },
        {
            "time": 0.8050000071525574,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.102,0.000,0.995",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.881,0.000,-0.473",
                "observationCamera,-1.451,0.378,-3.868,0.027,-0.955,0.096,0.278"
            ]
        },
        {
            "time": 0.8169999718666077,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.086,0.000,0.996",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.899,0.000,-0.439",
                "observationCamera,-1.451,0.378,-3.868,0.027,-0.955,0.096,0.278"
            ]
        },
        {
            "time": 0.828000009059906,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.071,0.000,0.997",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.914,0.000,-0.407",
                "observationCamera,-1.450,0.378,-3.868,0.027,-0.955,0.096,0.279"
            ]
        },
        {
            "time": 0.8399999737739563,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.058,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.926,0.000,-0.377",
                "observationCamera,-1.449,0.378,-3.868,0.027,-0.955,0.096,0.279"
            ]
        },
        {
            "time": 0.8529999852180481,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.042,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.939,0.000,-0.343",
                "observationCamera,-1.448,0.378,-3.869,0.027,-0.955,0.096,0.280"
            ]
        },
        {
            "time": 0.8659999966621399,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.027,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.951,0.000,-0.309",
                "observationCamera,-1.448,0.378,-3.869,0.027,-0.955,0.097,0.280"
            ]
        },
        {
            "time": 0.878000020980835,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.013,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.961,0.000,-0.276",
                "observationCamera,-1.447,0.378,-3.869,0.027,-0.955,0.097,0.280"
            ]
        },
        {
            "time": 0.8899999856948853,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.000,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.969,0.000,-0.248",
                "observationCamera,-1.446,0.378,-3.869,0.027,-0.955,0.097,0.281"
            ]
        },
        {
            "time": 0.9020000100135803,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.011,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.975,0.000,-0.221",
                "observationCamera,-1.445,0.378,-3.870,0.027,-0.954,0.097,0.281"
            ]
        },
        {
            "time": 0.9150000214576721,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.022,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.981,0.000,-0.195",
                "observationCamera,-1.445,0.378,-3.870,0.027,-0.954,0.097,0.282"
            ]
        },
        {
            "time": 0.9269999861717224,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.033,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.985,0.000,-0.171",
                "observationCamera,-1.444,0.378,-3.870,0.027,-0.954,0.097,0.282"
            ]
        },
        {
            "time": 0.9369999766349793,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.041,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.989,0.000,-0.150",
                "observationCamera,-1.443,0.378,-3.870,0.027,-0.954,0.097,0.282"
            ]
        },
        {
            "time": 0.949999988079071,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.048,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.991,0.000,-0.135",
                "observationCamera,-1.443,0.378,-3.870,0.027,-0.954,0.097,0.283"
            ]
        },
        {
            "time": 0.9620000123977661,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.055,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.993,0.000,-0.118",
                "observationCamera,-1.442,0.378,-3.871,0.028,-0.954,0.097,0.283"
            ]
        },
        {
            "time": 0.9750000238418579,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.061,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.994,0.000,-0.105",
                "observationCamera,-1.441,0.378,-3.871,0.028,-0.954,0.097,0.284"
            ]
        },
        {
            "time": 0.9869999885559082,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.065,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.995,0.000,-0.095",
                "observationCamera,-1.440,0.378,-3.871,0.028,-0.953,0.097,0.284"
            ]
        },
        {
            "time": 0.9990000128746033,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.067,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.089",
                "observationCamera,-1.439,0.378,-3.871,0.028,-0.953,0.097,0.284"
            ]
        },
        {
            "time": 1.0110000371932984,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.439,0.378,-3.872,0.028,-0.953,0.098,0.285"
            ]
        },
        {
            "time": 1.0230000019073487,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.438,0.378,-3.872,0.028,-0.953,0.098,0.285"
            ]
        },
        {
            "time": 1.034999966621399,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.437,0.378,-3.872,0.028,-0.953,0.098,0.286"
            ]
        },
        {
            "time": 1.0449999570846558,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.437,0.378,-3.872,0.028,-0.953,0.098,0.286"
            ]
        },
        {
            "time": 1.0579999685287476,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.436,0.378,-3.873,0.028,-0.953,0.098,0.286"
            ]
        },
        {
            "time": 1.0709999799728394,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.435,0.378,-3.873,0.028,-0.953,0.098,0.287"
            ]
        },
        {
            "time": 1.0829999446868897,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.434,0.378,-3.873,0.028,-0.952,0.098,0.287"
            ]
        },
        {
            "time": 1.0959999561309815,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.434,0.378,-3.873,0.028,-0.952,0.098,0.287"
            ]
        },
        {
            "time": 1.1069999933242798,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.433,0.378,-3.873,0.028,-0.952,0.098,0.288"
            ]
        },
        {
            "time": 1.1200000047683716,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.432,0.378,-3.874,0.028,-0.952,0.098,0.288"
            ]
        },
        {
            "time": 1.1319999694824219,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.431,0.378,-3.874,0.028,-0.952,0.098,0.289"
            ]
        },
        {
            "time": 1.1430000066757203,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.431,0.378,-3.874,0.028,-0.952,0.099,0.289"
            ]
        },
        {
            "time": 1.1540000438690186,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.430,0.378,-3.874,0.028,-0.952,0.099,0.289"
            ]
        },
        {
            "time": 1.1670000553131104,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.429,0.378,-3.875,0.028,-0.952,0.099,0.290"
            ]
        },
        {
            "time": 1.1790000200271607,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.429,0.378,-3.875,0.028,-0.951,0.099,0.290"
            ]
        },
        {
            "time": 1.1920000314712525,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.428,0.378,-3.875,0.029,-0.951,0.099,0.291"
            ]
        },
        {
            "time": 1.2039999961853028,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.427,0.378,-3.875,0.029,-0.951,0.099,0.291"
            ]
        },
        {
            "time": 1.215999960899353,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.426,0.378,-3.875,0.029,-0.951,0.099,0.291"
            ]
        },
        {
            "time": 1.2280000448226929,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.426,0.378,-3.876,0.029,-0.951,0.099,0.292"
            ]
        },
        {
            "time": 1.2410000562667847,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.425,0.378,-3.876,0.029,-0.951,0.099,0.292"
            ]
        },
        {
            "time": 1.253000020980835,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.424,0.378,-3.876,0.029,-0.951,0.099,0.293"
            ]
        },
        {
            "time": 1.2630000114440919,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.423,0.378,-3.876,0.029,-0.950,0.099,0.293"
            ]
        },
        {
            "time": 1.274999976158142,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.423,0.378,-3.877,0.029,-0.950,0.099,0.293"
            ]
        },
        {
            "time": 1.2879999876022339,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.422,0.378,-3.877,0.029,-0.950,0.100,0.294"
            ]
        },
        {
            "time": 1.3009999990463257,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.421,0.378,-3.877,0.029,-0.950,0.100,0.294"
            ]
        },
        {
            "time": 1.312999963760376,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.420,0.378,-3.877,0.029,-0.950,0.100,0.295"
            ]
        },
        {
            "time": 1.3240000009536744,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.420,0.378,-3.877,0.029,-0.950,0.100,0.295"
            ]
        },
        {
            "time": 1.3370000123977662,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.419,0.378,-3.878,0.029,-0.950,0.100,0.295"
            ]
        },
        {
            "time": 1.3489999771118165,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.418,0.377,-3.878,0.029,-0.950,0.100,0.296"
            ]
        },
        {
            "time": 1.3609999418258668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.417,0.377,-3.878,0.029,-0.949,0.100,0.296"
            ]
        },
        {
            "time": 1.371000051498413,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.417,0.377,-3.878,0.029,-0.949,0.100,0.297"
            ]
        },
        {
            "time": 1.3839999437332154,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.416,0.377,-3.879,0.029,-0.949,0.100,0.297"
            ]
        },
        {
            "time": 1.3969999551773072,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.415,0.377,-3.879,0.029,-0.949,0.100,0.297"
            ]
        },
        {
            "time": 1.409000039100647,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.414,0.377,-3.879,0.029,-0.949,0.100,0.298"
            ]
        },
        {
            "time": 1.4210000038146973,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.414,0.377,-3.879,0.030,-0.949,0.100,0.298"
            ]
        },
        {
            "time": 1.4329999685287476,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.413,0.377,-3.880,0.030,-0.949,0.101,0.299"
            ]
        },
        {
            "time": 1.4459999799728394,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.412,0.377,-3.880,0.030,-0.949,0.101,0.299"
            ]
        },
        {
            "time": 1.4579999446868897,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.411,0.377,-3.880,0.030,-0.948,0.101,0.299"
            ]
        },
        {
            "time": 1.4700000286102296,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.411,0.377,-3.880,0.030,-0.948,0.101,0.300"
            ]
        },
        {
            "time": 1.4800000190734864,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.410,0.377,-3.880,0.030,-0.948,0.101,0.300"
            ]
        },
        {
            "time": 1.4919999837875367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.409,0.377,-3.881,0.030,-0.948,0.101,0.300"
            ]
        },
        {
            "time": 1.5049999952316285,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.409,0.377,-3.881,0.030,-0.948,0.101,0.301"
            ]
        },
        {
            "time": 1.5180000066757203,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.408,0.377,-3.881,0.030,-0.948,0.101,0.301"
            ]
        },
        {
            "time": 1.5299999713897706,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.407,0.377,-3.881,0.030,-0.948,0.101,0.302"
            ]
        },
        {
            "time": 1.5410000085830689,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.406,0.377,-3.882,0.030,-0.947,0.101,0.302"
            ]
        },
        {
            "time": 1.5540000200271607,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.406,0.377,-3.882,0.030,-0.947,0.101,0.302"
            ]
        },
        {
            "time": 1.565999984741211,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.405,0.377,-3.882,0.030,-0.947,0.101,0.303"
            ]
        },
        {
            "time": 1.5779999494552613,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.404,0.377,-3.882,0.030,-0.947,0.102,0.303"
            ]
        },
        {
            "time": 1.5880000591278077,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.403,0.377,-3.882,0.030,-0.947,0.102,0.304"
            ]
        },
        {
            "time": 1.6009999513626099,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.403,0.377,-3.883,0.030,-0.947,0.102,0.304"
            ]
        },
        {
            "time": 1.6139999628067017,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.402,0.377,-3.883,0.030,-0.947,0.102,0.304"
            ]
        },
        {
            "time": 1.6260000467300416,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.401,0.377,-3.883,0.030,-0.946,0.102,0.305"
            ]
        },
        {
            "time": 1.6380000114440919,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.400,0.377,-3.883,0.030,-0.946,0.102,0.305"
            ]
        },
        {
            "time": 1.649999976158142,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.400,0.377,-3.884,0.031,-0.946,0.102,0.306"
            ]
        },
        {
            "time": 1.6619999408721924,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.399,0.377,-3.884,0.031,-0.946,0.102,0.306"
            ]
        },
        {
            "time": 1.6749999523162842,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.398,0.377,-3.884,0.031,-0.946,0.102,0.306"
            ]
        },
        {
            "time": 1.6859999895095826,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.397,0.377,-3.884,0.031,-0.946,0.102,0.307"
            ]
        },
        {
            "time": 1.6970000267028809,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.397,0.377,-3.884,0.031,-0.946,0.102,0.307"
            ]
        },
        {
            "time": 1.7089999914169312,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.396,0.377,-3.885,0.031,-0.946,0.102,0.307"
            ]
        },
        {
            "time": 1.722000002861023,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.395,0.377,-3.885,0.031,-0.945,0.103,0.308"
            ]
        },
        {
            "time": 1.7350000143051148,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.395,0.377,-3.885,0.031,-0.945,0.103,0.308"
            ]
        },
        {
            "time": 1.746999979019165,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.394,0.377,-3.885,0.031,-0.945,0.103,0.309"
            ]
        },
        {
            "time": 1.7589999437332154,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.393,0.377,-3.886,0.031,-0.945,0.103,0.309"
            ]
        },
        {
            "time": 1.7710000276565552,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.392,0.377,-3.886,0.031,-0.945,0.103,0.309"
            ]
        },
        {
            "time": 1.784000039100647,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.392,0.377,-3.886,0.031,-0.945,0.103,0.310"
            ]
        },
        {
            "time": 1.7949999570846558,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.391,0.377,-3.886,0.031,-0.945,0.103,0.310"
            ]
        },
        {
            "time": 1.8049999475479127,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.390,0.377,-3.886,0.031,-0.944,0.103,0.311"
            ]
        },
        {
            "time": 1.8179999589920045,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.390,0.377,-3.887,0.031,-0.944,0.103,0.311"
            ]
        },
        {
            "time": 1.8309999704360963,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.389,0.377,-3.887,0.031,-0.944,0.103,0.311"
            ]
        },
        {
            "time": 1.843000054359436,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.388,0.377,-3.887,0.031,-0.944,0.103,0.312"
            ]
        },
        {
            "time": 1.8550000190734864,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.387,0.377,-3.887,0.031,-0.944,0.103,0.312"
            ]
        },
        {
            "time": 1.8669999837875367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.386,0.377,-3.888,0.032,-0.944,0.104,0.313"
            ]
        },
        {
            "time": 1.8799999952316285,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.386,0.377,-3.888,0.032,-0.944,0.104,0.313"
            ]
        },
        {
            "time": 1.8919999599456788,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.385,0.377,-3.888,0.032,-0.943,0.104,0.313"
            ]
        },
        {
            "time": 1.9040000438690186,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.384,0.377,-3.888,0.032,-0.943,0.104,0.314"
            ]
        },
        {
            "time": 1.9140000343322755,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.384,0.377,-3.889,0.032,-0.943,0.104,0.314"
            ]
        },
        {
            "time": 1.9270000457763672,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.383,0.377,-3.889,0.032,-0.943,0.104,0.315"
            ]
        },
        {
            "time": 1.940000057220459,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.382,0.377,-3.889,0.032,-0.943,0.104,0.315"
            ]
        },
        {
            "time": 1.9520000219345093,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.381,0.377,-3.889,0.032,-0.943,0.104,0.315"
            ]
        },
        {
            "time": 1.9639999866485596,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.381,0.377,-3.889,0.032,-0.943,0.104,0.316"
            ]
        },
        {
            "time": 1.9759999513626099,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.380,0.376,-3.890,0.032,-0.942,0.104,0.316"
            ]
        },
        {
            "time": 1.9880000352859498,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.379,0.376,-3.890,0.032,-0.942,0.104,0.317"
            ]
        },
        {
            "time": 2.000999927520752,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.378,0.376,-3.890,0.032,-0.942,0.104,0.317"
            ]
        },
        {
            "time": 2.01200008392334,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.378,0.376,-3.890,0.032,-0.942,0.105,0.317"
            ]
        },
        {
            "time": 2.0230000019073488,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.377,0.376,-3.891,0.032,-0.942,0.105,0.318"
            ]
        },
        {
            "time": 2.0350000858306886,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.376,0.376,-3.891,0.032,-0.942,0.105,0.318"
            ]
        },
        {
            "time": 2.0480000972747804,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.375,0.376,-3.891,0.032,-0.942,0.105,0.318"
            ]
        },
        {
            "time": 2.061000108718872,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.375,0.376,-3.891,0.032,-0.941,0.105,0.319"
            ]
        },
        {
            "time": 2.072000026702881,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.374,0.376,-3.891,0.032,-0.941,0.105,0.319"
            ]
        },
        {
            "time": 2.0840001106262209,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.373,0.376,-3.892,0.033,-0.941,0.105,0.320"
            ]
        },
        {
            "time": 2.0969998836517336,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.372,0.376,-3.892,0.033,-0.941,0.105,0.320"
            ]
        },
        {
            "time": 2.1089999675750734,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.372,0.376,-3.892,0.033,-0.941,0.105,0.320"
            ]
        },
        {
            "time": 2.121000051498413,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.371,0.376,-3.892,0.033,-0.941,0.105,0.321"
            ]
        },
        {
            "time": 2.13100004196167,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.370,0.376,-3.893,0.033,-0.941,0.105,0.321"
            ]
        },
        {
            "time": 2.1440000534057619,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.370,0.376,-3.893,0.033,-0.940,0.105,0.322"
            ]
        },
        {
            "time": 2.1570000648498537,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.369,0.376,-3.893,0.033,-0.940,0.106,0.322"
            ]
        },
        {
            "time": 2.1689999103546144,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.368,0.376,-3.893,0.033,-0.940,0.106,0.322"
            ]
        },
        {
            "time": 2.180999994277954,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.367,0.376,-3.893,0.033,-0.940,0.106,0.323"
            ]
        },
        {
            "time": 2.193000078201294,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.367,0.376,-3.894,0.033,-0.940,0.106,0.323"
            ]
        },
        {
            "time": 2.2060000896453859,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.366,0.376,-3.894,0.033,-0.940,0.106,0.324"
            ]
        },
        {
            "time": 2.2179999351501467,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.365,0.376,-3.894,0.033,-0.940,0.106,0.324"
            ]
        },
        {
            "time": 2.2290000915527345,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.364,0.376,-3.894,0.033,-0.939,0.106,0.324"
            ]
        },
        {
            "time": 2.240000009536743,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.364,0.376,-3.895,0.033,-0.939,0.106,0.325"
            ]
        },
        {
            "time": 2.252000093460083,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.363,0.376,-3.895,0.033,-0.939,0.106,0.325"
            ]
        },
        {
            "time": 2.265000104904175,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.362,0.376,-3.895,0.033,-0.939,0.106,0.325"
            ]
        },
        {
            "time": 2.2780001163482668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.361,0.376,-3.895,0.033,-0.939,0.106,0.326"
            ]
        },
        {
            "time": 2.2899999618530275,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.361,0.376,-3.895,0.034,-0.939,0.106,0.326"
            ]
        },
        {
            "time": 2.302000045776367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.360,0.376,-3.896,0.034,-0.939,0.107,0.327"
            ]
        },
        {
            "time": 2.313999891281128,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.359,0.376,-3.896,0.034,-0.938,0.107,0.327"
            ]
        },
        {
            "time": 2.328000068664551,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.358,0.376,-3.896,0.034,-0.938,0.107,0.327"
            ]
        },
        {
            "time": 2.3380000591278078,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.358,0.376,-3.896,0.034,-0.938,0.107,0.328"
            ]
        },
        {
            "time": 2.3480000495910646,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.357,0.376,-3.897,0.034,-0.938,0.107,0.328"
            ]
        },
        {
            "time": 2.3610000610351564,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.356,0.376,-3.897,0.034,-0.938,0.107,0.329"
            ]
        },
        {
            "time": 2.374000072479248,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.356,0.376,-3.897,0.034,-0.938,0.107,0.329"
            ]
        },
        {
            "time": 2.38700008392334,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.355,0.376,-3.897,0.034,-0.937,0.107,0.329"
            ]
        },
        {
            "time": 2.3980000019073488,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.354,0.376,-3.897,0.034,-0.937,0.107,0.330"
            ]
        },
        {
            "time": 2.4100000858306886,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.353,0.376,-3.898,0.034,-0.937,0.107,0.330"
            ]
        },
        {
            "time": 2.4230000972747804,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.353,0.376,-3.898,0.034,-0.937,0.107,0.331"
            ]
        },
        {
            "time": 2.434999942779541,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.352,0.376,-3.898,0.034,-0.937,0.107,0.331"
            ]
        },
        {
            "time": 2.447000026702881,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.351,0.376,-3.898,0.034,-0.937,0.108,0.331"
            ]
        },
        {
            "time": 2.4570000171661379,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.350,0.376,-3.899,0.034,-0.937,0.108,0.332"
            ]
        },
        {
            "time": 2.4700000286102297,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.350,0.376,-3.899,0.034,-0.936,0.108,0.332"
            ]
        },
        {
            "time": 2.4830000400543215,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.349,0.376,-3.899,0.034,-0.936,0.108,0.332"
            ]
        },
        {
            "time": 2.494999885559082,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.348,0.376,-3.899,0.035,-0.936,0.108,0.333"
            ]
        },
        {
            "time": 2.506999969482422,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.347,0.376,-3.900,0.035,-0.936,0.108,0.333"
            ]
        },
        {
            "time": 2.5190000534057619,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.347,0.376,-3.900,0.035,-0.936,0.108,0.334"
            ]
        },
        {
            "time": 2.5320000648498537,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.346,0.376,-3.900,0.035,-0.936,0.108,0.334"
            ]
        },
        {
            "time": 2.5439999103546144,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.345,0.376,-3.900,0.035,-0.936,0.108,0.334"
            ]
        },
        {
            "time": 2.555999994277954,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.344,0.376,-3.900,0.035,-0.935,0.108,0.335"
            ]
        },
        {
            "time": 2.565999984741211,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.344,0.376,-3.901,0.035,-0.935,0.108,0.335"
            ]
        },
        {
            "time": 2.578000068664551,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.343,0.376,-3.901,0.035,-0.935,0.108,0.336"
            ]
        },
        {
            "time": 2.5910000801086427,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.342,0.376,-3.901,0.035,-0.935,0.109,0.336"
            ]
        },
        {
            "time": 2.6040000915527345,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.342,0.375,-3.901,0.035,-0.935,0.109,0.336"
            ]
        },
        {
            "time": 2.617000102996826,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.341,0.375,-3.902,0.035,-0.935,0.109,0.337"
            ]
        },
        {
            "time": 2.628000020980835,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.340,0.375,-3.902,0.035,-0.934,0.109,0.337"
            ]
        },
        {
            "time": 2.6410000324249269,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.339,0.375,-3.902,0.035,-0.934,0.109,0.338"
            ]
        },
        {
            "time": 2.6530001163482668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.338,0.375,-3.902,0.035,-0.934,0.109,0.338"
            ]
        },
        {
            "time": 2.6649999618530275,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.338,0.375,-3.902,0.035,-0.934,0.109,0.338"
            ]
        },
        {
            "time": 2.674999952316284,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.337,0.375,-3.903,0.035,-0.934,0.109,0.339"
            ]
        },
        {
            "time": 2.687999963760376,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.336,0.375,-3.903,0.036,-0.934,0.109,0.339"
            ]
        },
        {
            "time": 2.7009999752044679,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.336,0.375,-3.903,0.036,-0.934,0.109,0.339"
            ]
        },
        {
            "time": 2.7130000591278078,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.335,0.375,-3.903,0.036,-0.933,0.109,0.340"
            ]
        },
        {
            "time": 2.7249999046325685,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.334,0.375,-3.904,0.036,-0.933,0.109,0.340"
            ]
        },
        {
            "time": 2.736999988555908,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.333,0.375,-3.904,0.036,-0.933,0.110,0.341"
            ]
        },
        {
            "time": 2.75,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.333,0.375,-3.904,0.036,-0.933,0.110,0.341"
            ]
        },
        {
            "time": 2.76200008392334,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.332,0.375,-3.904,0.036,-0.933,0.110,0.341"
            ]
        },
        {
            "time": 2.7739999294281008,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.331,0.375,-3.905,0.036,-0.933,0.110,0.342"
            ]
        },
        {
            "time": 2.7839999198913576,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.330,0.375,-3.905,0.036,-0.933,0.110,0.342"
            ]
        },
        {
            "time": 2.796999931335449,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.330,0.375,-3.905,0.036,-0.932,0.110,0.343"
            ]
        },
        {
            "time": 2.809000015258789,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.329,0.375,-3.905,0.036,-0.932,0.110,0.343"
            ]
        },
        {
            "time": 2.822000026702881,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.328,0.375,-3.905,0.036,-0.932,0.110,0.343"
            ]
        },
        {
            "time": 2.8340001106262209,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.327,0.375,-3.906,0.036,-0.932,0.110,0.344"
            ]
        },
        {
            "time": 2.8459999561309816,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.327,0.375,-3.906,0.036,-0.932,0.110,0.344"
            ]
        },
        {
            "time": 2.8580000400543215,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.326,0.375,-3.906,0.036,-0.932,0.110,0.344"
            ]
        },
        {
            "time": 2.871000051498413,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.325,0.375,-3.906,0.036,-0.931,0.110,0.345"
            ]
        },
        {
            "time": 2.881999969482422,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.324,0.375,-3.907,0.037,-0.931,0.110,0.345"
            ]
        },
        {
            "time": 2.8929998874664308,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.324,0.375,-3.907,0.037,-0.931,0.111,0.346"
            ]
        },
        {
            "time": 2.9049999713897707,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.323,0.375,-3.907,0.037,-0.931,0.111,0.346"
            ]
        },
        {
            "time": 2.9179999828338625,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.322,0.375,-3.907,0.037,-0.931,0.111,0.346"
            ]
        },
        {
            "time": 2.930999994277954,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.322,0.375,-3.907,0.037,-0.931,0.111,0.347"
            ]
        },
        {
            "time": 2.943000078201294,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.321,0.375,-3.908,0.037,-0.930,0.111,0.347"
            ]
        },
        {
            "time": 2.9539999961853029,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.320,0.375,-3.908,0.037,-0.930,0.111,0.348"
            ]
        },
        {
            "time": 2.9670000076293947,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.319,0.375,-3.908,0.037,-0.930,0.111,0.348"
            ]
        },
        {
            "time": 2.9800000190734865,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.319,0.375,-3.908,0.037,-0.930,0.111,0.348"
            ]
        },
        {
            "time": 2.992000102996826,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.318,0.375,-3.909,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.000999927520752,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.317,0.375,-3.909,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.0139999389648439,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.317,0.375,-3.909,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.0269999504089357,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.068,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.316,0.375,-3.908,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.0399999618530275,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.067,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.316,0.375,-3.908,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.052000045776367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.067,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.837,0.000,-4.337,0.000,-0.996,0.000,-0.087",
                "observationCamera,-1.316,0.375,-3.908,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.062999963760376,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.066,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.838,0.000,-4.338,0.000,-0.996,0.000,-0.086",
                "observationCamera,-1.316,0.375,-3.907,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.0759999752044679,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.065,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.838,0.000,-4.338,0.000,-0.996,0.000,-0.086",
                "observationCamera,-1.316,0.375,-3.907,0.037,-0.930,0.111,0.349"
            ]
        },
        {
            "time": 3.0889999866485597,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.063,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.839,0.000,-4.339,0.000,-0.996,0.000,-0.086",
                "observationCamera,-1.316,0.375,-3.907,0.037,-0.930,0.111,0.348"
            ]
        },
        {
            "time": 3.0999999046325685,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.061,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.839,0.000,-4.339,0.000,-0.996,0.000,-0.085",
                "observationCamera,-1.315,0.375,-3.906,0.037,-0.930,0.111,0.348"
            ]
        },
        {
            "time": 3.109999895095825,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.060,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.840,0.000,-4.340,0.000,-0.996,0.000,-0.084",
                "observationCamera,-1.315,0.375,-3.906,0.037,-0.930,0.111,0.348"
            ]
        },
        {
            "time": 3.122999906539917,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.058,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.840,0.000,-4.340,0.000,-0.996,0.000,-0.084",
                "observationCamera,-1.315,0.375,-3.906,0.037,-0.930,0.110,0.348"
            ]
        },
        {
            "time": 3.135999917984009,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.056,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.841,0.000,-4.341,0.000,-0.997,0.000,-0.083",
                "observationCamera,-1.315,0.375,-3.905,0.037,-0.930,0.110,0.348"
            ]
        },
        {
            "time": 3.1500000953674318,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.053,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.842,0.000,-4.342,0.000,-0.997,0.000,-0.082",
                "observationCamera,-1.315,0.375,-3.905,0.037,-0.930,0.110,0.348"
            ]
        },
        {
            "time": 3.1610000133514406,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.050,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.843,0.000,-4.343,0.000,-0.997,0.000,-0.081",
                "observationCamera,-1.314,0.375,-3.904,0.036,-0.930,0.110,0.348"
            ]
        },
        {
            "time": 3.1740000247955324,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.047,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.844,0.000,-4.344,0.000,-0.997,0.000,-0.080",
                "observationCamera,-1.314,0.375,-3.904,0.036,-0.930,0.110,0.347"
            ]
        },
        {
            "time": 3.184999942779541,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.044,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.845,0.000,-4.345,0.000,-0.997,0.000,-0.079",
                "observationCamera,-1.314,0.375,-3.904,0.036,-0.931,0.110,0.347"
            ]
        },
        {
            "time": 3.2009999752044679,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.041,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.847,0.000,-4.347,0.000,-0.997,0.000,-0.078",
                "observationCamera,-1.314,0.375,-3.903,0.036,-0.931,0.110,0.347"
            ]
        },
        {
            "time": 3.2100000381469728,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.036,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.848,0.000,-4.348,0.000,-0.997,0.000,-0.076",
                "observationCamera,-1.314,0.375,-3.903,0.036,-0.931,0.110,0.347"
            ]
        },
        {
            "time": 3.2190001010894777,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.033,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.849,0.000,-4.349,0.000,-0.997,0.000,-0.075",
                "observationCamera,-1.314,0.375,-3.902,0.036,-0.931,0.110,0.347"
            ]
        },
        {
            "time": 3.2320001125335695,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.030,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.850,0.000,-4.350,0.000,-0.997,0.000,-0.074",
                "observationCamera,-1.314,0.375,-3.902,0.036,-0.931,0.110,0.347"
            ]
        },
        {
            "time": 3.246999979019165,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.026,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.852,0.000,-4.352,0.000,-0.997,0.000,-0.073",
                "observationCamera,-1.313,0.375,-3.902,0.036,-0.931,0.109,0.347"
            ]
        },
        {
            "time": 3.257999897003174,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.021,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.854,0.000,-4.354,0.000,-0.997,0.000,-0.071",
                "observationCamera,-1.313,0.375,-3.901,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.2709999084472658,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.017,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.855,0.000,-4.355,0.000,-0.998,0.000,-0.069",
                "observationCamera,-1.313,0.375,-3.901,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.2820000648498537,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.012,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.857,0.000,-4.357,0.000,-0.998,0.000,-0.068",
                "observationCamera,-1.313,0.375,-3.901,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.2950000762939455,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.008,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.858,0.000,-4.358,0.000,-0.998,0.000,-0.066",
                "observationCamera,-1.313,0.375,-3.900,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.308000087738037,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,-0.003,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.860,0.000,-4.360,0.000,-0.998,0.000,-0.064",
                "observationCamera,-1.312,0.375,-3.900,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.319000005722046,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.003,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.862,0.000,-4.362,0.000,-0.998,0.000,-0.062",
                "observationCamera,-1.312,0.375,-3.899,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.3289999961853029,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.007,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.864,0.000,-4.364,0.000,-0.998,0.000,-0.061",
                "observationCamera,-1.312,0.375,-3.899,0.036,-0.931,0.109,0.346"
            ]
        },
        {
            "time": 3.3440001010894777,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.012,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.866,0.000,-4.366,0.000,-0.998,0.000,-0.059",
                "observationCamera,-1.312,0.375,-3.899,0.036,-0.931,0.109,0.345"
            ]
        },
        {
            "time": 3.3580000400543215,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.019,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.868,0.000,-4.368,0.000,-0.998,0.000,-0.056",
                "observationCamera,-1.312,0.375,-3.898,0.036,-0.932,0.109,0.345"
            ]
        },
        {
            "time": 3.368000030517578,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.025,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.870,0.000,-4.370,0.000,-0.999,0.000,-0.054",
                "observationCamera,-1.312,0.375,-3.898,0.036,-0.932,0.108,0.345"
            ]
        },
        {
            "time": 3.381999969482422,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.030,0.000,1.000",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.872,0.000,-4.372,0.000,-0.999,0.000,-0.052",
                "observationCamera,-1.311,0.375,-3.898,0.035,-0.932,0.108,0.345"
            ]
        },
        {
            "time": 3.3919999599456789,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.036,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.875,0.000,-4.375,0.000,-0.999,0.000,-0.050",
                "observationCamera,-1.311,0.375,-3.897,0.035,-0.932,0.108,0.345"
            ]
        },
        {
            "time": 3.4059998989105226,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.041,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.877,0.000,-4.377,0.000,-0.999,0.000,-0.048",
                "observationCamera,-1.311,0.375,-3.897,0.035,-0.932,0.108,0.345"
            ]
        },
        {
            "time": 3.4210000038146974,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.048,0.000,0.999",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.879,0.000,-4.379,0.000,-0.999,0.000,-0.045",
                "observationCamera,-1.311,0.376,-3.896,0.035,-0.932,0.108,0.345"
            ]
        },
        {
            "time": 3.430999994277954,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.056,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.882,0.000,-4.382,0.000,-0.999,0.000,-0.042",
                "observationCamera,-1.311,0.376,-3.896,0.035,-0.932,0.108,0.344"
            ]
        },
        {
            "time": 3.440999984741211,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.061,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.884,0.000,-4.384,0.000,-0.999,0.000,-0.040",
                "observationCamera,-1.311,0.376,-3.896,0.035,-0.932,0.108,0.344"
            ]
        },
        {
            "time": 3.4519999027252199,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.066,0.000,0.998",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.886,0.000,-4.386,0.000,-0.999,0.000,-0.038",
                "observationCamera,-1.310,0.376,-3.895,0.035,-0.932,0.108,0.344"
            ]
        },
        {
            "time": 3.4670000076293947,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.072,0.000,0.997",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.889,0.000,-4.389,0.000,-0.999,0.000,-0.036",
                "observationCamera,-1.310,0.376,-3.895,0.035,-0.932,0.108,0.344"
            ]
        },
        {
            "time": 3.4779999256134035,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.080,0.000,0.997",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.892,0.000,-4.392,0.000,-0.999,0.000,-0.033",
                "observationCamera,-1.310,0.376,-3.895,0.035,-0.932,0.108,0.344"
            ]
        },
        {
            "time": 3.490999937057495,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.086,0.000,0.996",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.894,0.000,-4.394,0.000,-1.000,0.000,-0.031",
                "observationCamera,-1.310,0.376,-3.894,0.035,-0.932,0.107,0.344"
            ]
        },
        {
            "time": 3.502000093460083,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.093,0.000,0.996",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.897,0.000,-4.397,0.000,-1.000,0.000,-0.028",
                "observationCamera,-1.310,0.376,-3.894,0.035,-0.932,0.107,0.344"
            ]
        },
        {
            "time": 3.515000104904175,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.100,0.000,0.995",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.899,0.000,-4.399,0.000,-1.000,0.000,-0.025",
                "observationCamera,-1.310,0.376,-3.894,0.035,-0.932,0.107,0.343"
            ]
        },
        {
            "time": 3.5269999504089357,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.107,0.000,0.994",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.902,0.000,-4.402,0.000,-1.000,0.000,-0.022",
                "observationCamera,-1.309,0.376,-3.893,0.035,-0.932,0.107,0.343"
            ]
        },
        {
            "time": 3.5390000343322756,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.114,0.000,0.993",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.905,0.000,-4.405,0.000,-1.000,0.000,-0.020",
                "observationCamera,-1.309,0.376,-3.893,0.035,-0.933,0.107,0.343"
            ]
        },
        {
            "time": 3.549999952316284,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.120,0.000,0.993",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.908,0.000,-4.408,0.000,-1.000,0.000,-0.017",
                "observationCamera,-1.309,0.376,-3.892,0.035,-0.933,0.107,0.343"
            ]
        },
        {
            "time": 3.562999963760376,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.127,0.000,0.992",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.910,0.000,-4.410,0.000,-1.000,0.000,-0.015",
                "observationCamera,-1.309,0.376,-3.892,0.035,-0.933,0.107,0.343"
            ]
        },
        {
            "time": 3.5759999752044679,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.134,0.000,0.991",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.913,0.000,-4.413,0.000,-1.000,0.000,-0.011",
                "observationCamera,-1.309,0.376,-3.892,0.035,-0.933,0.107,0.343"
            ]
        },
        {
            "time": 3.5899999141693117,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.142,0.000,0.990",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.917,0.000,-4.417,0.000,-1.000,0.000,-0.008",
                "observationCamera,-1.309,0.376,-3.891,0.035,-0.933,0.107,0.342"
            ]
        },
        {
            "time": 3.6010000705718996,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.150,0.000,0.989",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.920,0.000,-4.420,0.000,-1.000,0.000,-0.005",
                "observationCamera,-1.308,0.376,-3.891,0.034,-0.933,0.107,0.342"
            ]
        },
        {
            "time": 3.615000009536743,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.157,0.000,0.988",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.923,0.000,-4.423,0.000,-1.000,0.000,-0.002",
                "observationCamera,-1.308,0.376,-3.890,0.034,-0.933,0.106,0.342"
            ]
        },
        {
            "time": 3.627000093460083,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.165,0.000,0.986",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.926,0.000,-4.426,0.000,-1.000,0.000,0.001",
                "observationCamera,-1.308,0.376,-3.890,0.034,-0.933,0.106,0.342"
            ]
        },
        {
            "time": 3.6389999389648439,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.172,0.000,0.985",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.929,0.000,-4.429,0.000,-1.000,0.000,0.004",
                "observationCamera,-1.308,0.376,-3.890,0.034,-0.933,0.106,0.342"
            ]
        },
        {
            "time": 3.6530001163482668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.179,0.000,0.984",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.932,0.000,-4.432,0.000,-1.000,0.000,0.007",
                "observationCamera,-1.308,0.376,-3.889,0.034,-0.933,0.106,0.342"
            ]
        },
        {
            "time": 3.6610000133514406,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.188,0.000,0.982",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.936,0.000,-4.436,0.000,-1.000,0.000,0.011",
                "observationCamera,-1.308,0.376,-3.889,0.034,-0.933,0.106,0.342"
            ]
        },
        {
            "time": 3.6740000247955324,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.193,0.000,0.981",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.938,0.000,-4.438,0.000,-1.000,0.000,0.013",
                "observationCamera,-1.307,0.376,-3.889,0.034,-0.933,0.106,0.341"
            ]
        },
        {
            "time": 3.687999963760376,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.200,0.000,0.980",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.942,0.000,-4.442,0.000,-1.000,0.000,0.016",
                "observationCamera,-1.307,0.376,-3.888,0.034,-0.933,0.106,0.341"
            ]
        },
        {
            "time": 3.6989998817443849,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.209,0.000,0.978",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.945,0.000,-4.445,0.000,-1.000,0.000,0.020",
                "observationCamera,-1.307,0.376,-3.888,0.034,-0.933,0.106,0.341"
            ]
        },
        {
            "time": 3.7139999866485597,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.216,0.000,0.976",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.948,0.000,-4.448,0.000,-1.000,0.000,0.023",
                "observationCamera,-1.307,0.376,-3.887,0.034,-0.933,0.106,0.341"
            ]
        },
        {
            "time": 3.7239999771118166,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.224,0.000,0.975",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.952,0.000,-4.452,0.000,-1.000,0.000,0.027",
                "observationCamera,-1.307,0.376,-3.887,0.034,-0.934,0.106,0.341"
            ]
        },
        {
            "time": 3.736999988555908,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.230,0.000,0.973",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.955,0.000,-4.455,0.000,-1.000,0.000,0.030",
                "observationCamera,-1.307,0.376,-3.887,0.034,-0.934,0.105,0.341"
            ]
        },
        {
            "time": 3.75,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.238,0.000,0.971",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.959,0.000,-4.459,0.000,-0.999,0.000,0.033",
                "observationCamera,-1.306,0.376,-3.886,0.034,-0.934,0.105,0.341"
            ]
        },
        {
            "time": 3.7660000324249269,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.246,0.000,0.969",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.962,0.000,-4.462,0.000,-0.999,0.000,0.037",
                "observationCamera,-1.306,0.376,-3.886,0.034,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.7709999084472658,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.255,0.000,0.967",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.967,0.000,-4.467,0.000,-0.999,0.000,0.041",
                "observationCamera,-1.306,0.376,-3.885,0.034,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.7850000858306886,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.258,0.000,0.966",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.968,0.000,-4.468,0.000,-0.999,0.000,0.043",
                "observationCamera,-1.306,0.376,-3.885,0.034,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.799999952316284,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.266,0.000,0.964",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.972,0.000,-4.472,0.000,-0.999,0.000,0.047",
                "observationCamera,-1.306,0.376,-3.885,0.034,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.812999963760376,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.275,0.000,0.962",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.976,0.000,-4.476,0.000,-0.999,0.000,0.051",
                "observationCamera,-1.306,0.376,-3.884,0.034,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.8239998817443849,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.282,0.000,0.959",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.980,0.000,-4.480,0.000,-0.999,0.000,0.055",
                "observationCamera,-1.305,0.376,-3.884,0.033,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.8359999656677248,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.289,0.000,0.957",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.983,0.000,-4.483,0.000,-0.998,0.000,0.058",
                "observationCamera,-1.305,0.376,-3.884,0.033,-0.934,0.105,0.340"
            ]
        },
        {
            "time": 3.8499999046325685,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.295,0.000,0.955",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.987,0.000,-4.487,0.000,-0.998,0.000,0.061",
                "observationCamera,-1.305,0.376,-3.883,0.033,-0.934,0.105,0.339"
            ]
        },
        {
            "time": 3.86299991607666,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.303,0.000,0.953",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.991,0.000,-4.491,0.000,-0.998,0.000,0.065",
                "observationCamera,-1.305,0.376,-3.883,0.033,-0.934,0.104,0.339"
            ]
        },
        {
            "time": 3.875999927520752,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.310,0.000,0.951",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.994,0.000,-4.494,0.000,-0.998,0.000,0.069",
                "observationCamera,-1.305,0.376,-3.882,0.033,-0.934,0.104,0.339"
            ]
        },
        {
            "time": 3.882999897003174,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.318,0.000,0.948",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-1.998,0.000,-4.498,0.000,-0.997,0.000,0.073",
                "observationCamera,-1.304,0.376,-3.882,0.033,-0.934,0.104,0.339"
            ]
        },
        {
            "time": 3.8970000743865969,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.321,0.000,0.947",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.000,0.000,-4.500,0.000,-0.997,0.000,0.075",
                "observationCamera,-1.304,0.376,-3.882,0.033,-0.934,0.104,0.339"
            ]
        },
        {
            "time": 3.9110000133514406,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.329,0.000,0.944",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.004,0.000,-4.504,0.000,-0.997,0.000,0.079",
                "observationCamera,-1.304,0.376,-3.881,0.033,-0.935,0.104,0.339"
            ]
        },
        {
            "time": 3.9240000247955324,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.336,0.000,0.942",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.009,0.000,-4.509,0.000,-0.997,0.000,0.083",
                "observationCamera,-1.304,0.376,-3.881,0.033,-0.935,0.104,0.338"
            ]
        },
        {
            "time": 3.937000036239624,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.343,0.000,0.939",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.013,0.000,-4.513,0.000,-0.996,0.000,0.087",
                "observationCamera,-1.304,0.376,-3.881,0.033,-0.935,0.104,0.338"
            ]
        },
        {
            "time": 3.9489998817443849,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.350,0.000,0.937",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.016,0.000,-4.516,0.000,-0.996,0.000,0.091",
                "observationCamera,-1.304,0.376,-3.880,0.033,-0.935,0.104,0.338"
            ]
        },
        {
            "time": 3.9609999656677248,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.356,0.000,0.935",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.020,0.000,-4.520,0.000,-0.996,0.000,0.094",
                "observationCamera,-1.303,0.376,-3.880,0.033,-0.935,0.104,0.338"
            ]
        },
        {
            "time": 3.9769999980926515,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.362,0.000,0.932",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.023,0.000,-4.523,0.000,-0.995,0.000,0.097",
                "observationCamera,-1.303,0.376,-3.879,0.033,-0.935,0.104,0.338"
            ]
        },
        {
            "time": 3.984999895095825,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.369,0.000,0.929",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.028,0.000,-4.528,0.000,-0.995,0.000,0.102",
                "observationCamera,-1.303,0.376,-3.879,0.033,-0.935,0.103,0.338"
            ]
        },
        {
            "time": 3.997999906539917,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.373,0.000,0.928",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.030,0.000,-4.530,0.000,-0.995,0.000,0.104",
                "observationCamera,-1.303,0.376,-3.879,0.033,-0.935,0.103,0.338"
            ]
        },
        {
            "time": 4.01200008392334,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.379,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.034,0.000,-4.534,0.000,-0.994,0.000,0.108",
                "observationCamera,-1.303,0.376,-3.878,0.033,-0.935,0.103,0.337"
            ]
        },
        {
            "time": 4.02400016784668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.386,0.000,0.923",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.039,0.000,-4.539,0.000,-0.994,0.000,0.112",
                "observationCamera,-1.303,0.377,-3.878,0.033,-0.935,0.103,0.337"
            ]
        },
        {
            "time": 4.038000106811523,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.391,0.000,0.920",
                "police2,-1.670,0.000,-4.617,0.000,0.379,0.000,0.925",
                "security,-2.042,0.000,-4.542,0.000,-0.993,0.000,0.116",
                "observationCamera,-1.302,0.377,-3.878,0.033,-0.935,0.103,0.337"
            ]
        },
        {
            "time": 4.048999786376953,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.398,0.000,0.917",
                "police2,-1.670,0.000,-4.617,0.000,0.377,0.000,0.926",
                "security,-2.046,0.000,-4.546,0.000,-0.993,0.000,0.120",
                "observationCamera,-1.302,0.377,-3.877,0.032,-0.935,0.103,0.337"
            ]
        },
        {
            "time": 4.065000057220459,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.404,0.000,0.915",
                "police2,-1.670,0.000,-4.617,0.000,0.375,0.000,0.927",
                "security,-2.049,0.000,-4.549,0.000,-0.992,0.000,0.123",
                "observationCamera,-1.302,0.377,-3.877,0.032,-0.935,0.103,0.337"
            ]
        },
        {
            "time": 4.073999881744385,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.412,0.000,0.911",
                "police2,-1.670,0.000,-4.617,0.000,0.371,0.000,0.929",
                "security,-2.054,0.000,-4.554,0.000,-0.992,0.000,0.128",
                "observationCamera,-1.302,0.377,-3.876,0.032,-0.935,0.103,0.337"
            ]
        },
        {
            "time": 4.083000183105469,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.417,0.000,0.909",
                "police2,-1.670,0.000,-4.617,0.000,0.369,0.000,0.930",
                "security,-2.057,0.000,-4.557,0.000,-0.991,0.000,0.130",
                "observationCamera,-1.302,0.377,-3.876,0.032,-0.936,0.103,0.337"
            ]
        },
        {
            "time": 4.098999977111816,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.422,0.000,0.907",
                "police2,-1.670,0.000,-4.617,0.000,0.365,0.000,0.931",
                "security,-2.060,0.000,-4.560,0.000,-0.991,0.000,0.133",
                "observationCamera,-1.302,0.377,-3.876,0.032,-0.936,0.103,0.336"
            ]
        },
        {
            "time": 4.111000061035156,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.430,0.000,0.903",
                "police2,-1.670,0.000,-4.617,0.000,0.360,0.000,0.933",
                "security,-2.064,0.000,-4.564,0.000,-0.990,0.000,0.138",
                "observationCamera,-1.301,0.377,-3.875,0.032,-0.936,0.102,0.336"
            ]
        },
        {
            "time": 4.125,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.437,0.000,0.899",
                "police2,-1.670,0.000,-4.617,0.000,0.354,0.000,0.935",
                "security,-2.068,0.000,-4.568,0.000,-0.990,0.000,0.141",
                "observationCamera,-1.301,0.377,-3.875,0.032,-0.936,0.102,0.336"
            ]
        },
        {
            "time": 4.135000228881836,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.445,0.000,0.896",
                "police2,-1.670,0.000,-4.617,0.000,0.348,0.000,0.938",
                "security,-2.072,0.000,-4.572,0.000,-0.989,0.000,0.145",
                "observationCamera,-1.301,0.377,-3.874,0.032,-0.936,0.102,0.336"
            ]
        },
        {
            "time": 4.146999835968018,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.451,0.000,0.893",
                "police2,-1.670,0.000,-4.617,0.000,0.342,0.000,0.940",
                "security,-2.075,0.000,-4.575,0.000,-0.989,0.000,0.148",
                "observationCamera,-1.301,0.377,-3.874,0.032,-0.936,0.102,0.336"
            ]
        },
        {
            "time": 4.160999774932861,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.458,0.000,0.889",
                "police2,-1.670,0.000,-4.617,0.000,0.336,0.000,0.942",
                "security,-2.078,0.000,-4.578,0.000,-0.988,0.000,0.152",
                "observationCamera,-1.301,0.377,-3.874,0.032,-0.936,0.102,0.336"
            ]
        },
        {
            "time": 4.173999786376953,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.466,0.000,0.885",
                "police2,-1.670,0.000,-4.617,0.000,0.328,0.000,0.945",
                "security,-2.082,0.000,-4.582,0.000,-0.988,0.000,0.155",
                "observationCamera,-1.301,0.377,-3.873,0.032,-0.936,0.102,0.335"
            ]
        },
        {
            "time": 4.184999942779541,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.473,0.000,0.881",
                "police2,-1.670,0.000,-4.617,0.000,0.319,0.000,0.948",
                "security,-2.086,0.000,-4.586,0.000,-0.987,0.000,0.159",
                "observationCamera,-1.300,0.377,-3.873,0.032,-0.936,0.102,0.335"
            ]
        },
        {
            "time": 4.196000099182129,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.480,0.000,0.877",
                "police2,-1.670,0.000,-4.617,0.000,0.311,0.000,0.950",
                "security,-2.089,0.000,-4.589,0.000,-0.987,0.000,0.162",
                "observationCamera,-1.300,0.377,-3.873,0.032,-0.936,0.102,0.335"
            ]
        },
        {
            "time": 4.211999893188477,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.486,0.000,0.874",
                "police2,-1.670,0.000,-4.617,0.000,0.303,0.000,0.953",
                "security,-2.093,0.000,-4.593,0.000,-0.986,0.000,0.165",
                "observationCamera,-1.300,0.377,-3.872,0.032,-0.936,0.102,0.335"
            ]
        },
        {
            "time": 4.2230000495910648,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.496,0.000,0.869",
                "police2,-1.670,0.000,-4.617,0.000,0.292,0.000,0.956",
                "security,-2.097,0.000,-4.597,0.000,-0.985,0.000,0.170",
                "observationCamera,-1.300,0.377,-3.872,0.032,-0.936,0.102,0.335"
            ]
        },
        {
            "time": 4.23799991607666,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.502,0.000,0.865",
                "police2,-1.670,0.000,-4.617,0.000,0.283,0.000,0.959",
                "security,-2.100,0.000,-4.600,0.000,-0.985,0.000,0.173",
                "observationCamera,-1.300,0.377,-3.871,0.032,-0.936,0.101,0.335"
            ]
        },
        {
            "time": 4.249000072479248,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.511,0.000,0.859",
                "police2,-1.670,0.000,-4.617,0.000,0.270,0.000,0.963",
                "security,-2.104,0.000,-4.604,0.000,-0.984,0.000,0.177",
                "observationCamera,-1.299,0.377,-3.871,0.032,-0.936,0.101,0.335"
            ]
        },
        {
            "time": 4.26200008392334,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.518,0.000,0.855",
                "police2,-1.670,0.000,-4.617,0.000,0.261,0.000,0.965",
                "security,-2.108,0.000,-4.608,0.000,-0.984,0.000,0.180",
                "observationCamera,-1.299,0.377,-3.871,0.032,-0.936,0.101,0.334"
            ]
        },
        {
            "time": 4.2789998054504398,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.526,0.000,0.851",
                "police2,-1.670,0.000,-4.617,0.000,0.249,0.000,0.968",
                "security,-2.111,0.000,-4.611,0.000,-0.983,0.000,0.183",
                "observationCamera,-1.299,0.377,-3.870,0.031,-0.937,0.101,0.334"
            ]
        },
        {
            "time": 4.288000106811523,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.536,0.000,0.844",
                "police2,-1.670,0.000,-4.617,0.000,0.234,0.000,0.972",
                "security,-2.116,0.000,-4.616,0.000,-0.982,0.000,0.188",
                "observationCamera,-1.299,0.377,-3.870,0.031,-0.937,0.101,0.334"
            ]
        },
        {
            "time": 4.296999931335449,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.541,0.000,0.841",
                "police2,-1.670,0.000,-4.617,0.000,0.224,0.000,0.974",
                "security,-2.118,0.000,-4.618,0.000,-0.982,0.000,0.190",
                "observationCamera,-1.299,0.377,-3.869,0.031,-0.937,0.101,0.334"
            ]
        },
        {
            "time": 4.309999942779541,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.547,0.000,0.837",
                "police2,-1.670,0.000,-4.617,0.000,0.216,0.000,0.976",
                "security,-2.121,0.000,-4.621,0.000,-0.981,0.000,0.193",
                "observationCamera,-1.299,0.377,-3.869,0.031,-0.937,0.101,0.334"
            ]
        },
        {
            "time": 4.322999954223633,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.555,0.000,0.832",
                "police2,-1.670,0.000,-4.617,0.000,0.203,0.000,0.979",
                "security,-2.124,0.000,-4.624,0.000,-0.981,0.000,0.196",
                "observationCamera,-1.298,0.377,-3.869,0.031,-0.937,0.101,0.334"
            ]
        },
        {
            "time": 4.335999965667725,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.562,0.000,0.827",
                "police2,-1.670,0.000,-4.617,0.000,0.189,0.000,0.982",
                "security,-2.128,0.000,-4.628,0.000,-0.980,0.000,0.200",
                "observationCamera,-1.298,0.377,-3.868,0.031,-0.937,0.101,0.333"
            ]
        },
        {
            "time": 4.35099983215332,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.570,0.000,0.821",
                "police2,-1.670,0.000,-4.617,0.000,0.175,0.000,0.985",
                "security,-2.131,0.000,-4.631,0.000,-0.979,0.000,0.203",
                "observationCamera,-1.298,0.377,-3.868,0.031,-0.937,0.100,0.333"
            ]
        },
        {
            "time": 4.36299991607666,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.579,0.000,0.815",
                "police2,-1.670,0.000,-4.617,0.000,0.159,0.000,0.987",
                "security,-2.135,0.000,-4.635,0.000,-0.978,0.000,0.207",
                "observationCamera,-1.298,0.377,-3.867,0.031,-0.937,0.100,0.333"
            ]
        },
        {
            "time": 4.379000186920166,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.586,0.000,0.810",
                "police2,-1.670,0.000,-4.617,0.000,0.146,0.000,0.989",
                "security,-2.138,0.000,-4.638,0.000,-0.978,0.000,0.210",
                "observationCamera,-1.298,0.377,-3.867,0.031,-0.937,0.100,0.333"
            ]
        },
        {
            "time": 4.388999938964844,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.595,0.000,0.803",
                "police2,-1.670,0.000,-4.617,0.000,0.128,0.000,0.992",
                "security,-2.142,0.000,-4.642,0.000,-0.977,0.000,0.214",
                "observationCamera,-1.298,0.377,-3.867,0.031,-0.937,0.100,0.333"
            ]
        },
        {
            "time": 4.3979997634887699,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.601,0.000,0.799",
                "police2,-1.670,0.000,-4.617,0.000,0.117,0.000,0.993",
                "security,-2.145,0.000,-4.645,0.000,-0.976,0.000,0.216",
                "observationCamera,-1.297,0.377,-3.866,0.031,-0.937,0.100,0.333"
            ]
        },
        {
            "time": 4.410999774932861,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.606,0.000,0.795",
                "police2,-1.670,0.000,-4.617,0.000,0.106,0.000,0.994",
                "security,-2.147,0.000,-4.647,0.000,-0.976,0.000,0.218",
                "observationCamera,-1.297,0.377,-3.866,0.031,-0.937,0.100,0.333"
            ]
        },
        {
            "time": 4.426000118255615,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.613,0.000,0.790",
                "police2,-1.670,0.000,-4.617,0.000,0.091,0.000,0.996",
                "security,-2.150,0.000,-4.650,0.000,-0.975,0.000,0.221",
                "observationCamera,-1.297,0.377,-3.866,0.031,-0.937,0.100,0.332"
            ]
        },
        {
            "time": 4.436999797821045,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.622,0.000,0.783",
                "police2,-1.670,0.000,-4.617,0.000,0.073,0.000,0.997",
                "security,-2.154,0.000,-4.654,0.000,-0.974,0.000,0.225",
                "observationCamera,-1.297,0.377,-3.865,0.031,-0.937,0.100,0.332"
            ]
        },
        {
            "time": 4.449999809265137,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.628,0.000,0.778",
                "police2,-1.670,0.000,-4.617,0.000,0.060,0.000,0.998",
                "security,-2.157,0.000,-4.657,0.000,-0.974,0.000,0.228",
                "observationCamera,-1.297,0.377,-3.865,0.031,-0.937,0.100,0.332"
            ]
        },
        {
            "time": 4.461999893188477,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.635,0.000,0.772",
                "police2,-1.670,0.000,-4.617,0.000,0.044,0.000,0.999",
                "security,-2.160,0.000,-4.660,0.000,-0.973,0.000,0.231",
                "observationCamera,-1.297,0.377,-3.864,0.031,-0.938,0.100,0.332"
            ]
        },
        {
            "time": 4.47599983215332,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.642,0.000,0.767",
                "police2,-1.670,0.000,-4.617,0.000,0.030,0.000,1.000",
                "security,-2.162,0.000,-4.662,0.000,-0.972,0.000,0.233",
                "observationCamera,-1.296,0.377,-3.864,0.031,-0.938,0.099,0.332"
            ]
        },
        {
            "time": 4.48799991607666,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.650,0.000,0.760",
                "police2,-1.670,0.000,-4.617,0.000,0.013,0.000,1.000",
                "security,-2.166,0.000,-4.666,0.000,-0.972,0.000,0.236",
                "observationCamera,-1.296,0.377,-3.864,0.031,-0.938,0.099,0.332"
            ]
        },
        {
            "time": 4.502999782562256,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.656,0.000,0.755",
                "police2,-1.670,0.000,-4.617,0.000,-0.001,0.000,1.000",
                "security,-2.168,0.000,-4.668,0.000,-0.971,0.000,0.239",
                "observationCamera,-1.296,0.377,-3.863,0.030,-0.938,0.099,0.332"
            ]
        },
        {
            "time": 4.510000228881836,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.664,0.000,0.748",
                "police2,-1.670,0.000,-4.617,0.000,-0.020,0.000,1.000",
                "security,-2.172,0.000,-4.672,0.000,-0.970,0.000,0.242",
                "observationCamera,-1.296,0.377,-3.863,0.030,-0.938,0.099,0.331"
            ]
        },
        {
            "time": 4.525000095367432,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.667,0.000,0.745",
                "police2,-1.670,0.000,-4.617,0.000,-0.029,0.000,1.000",
                "security,-2.173,0.000,-4.673,0.000,-0.970,0.000,0.244",
                "observationCamera,-1.296,0.377,-3.863,0.030,-0.938,0.099,0.331"
            ]
        },
        {
            "time": 4.535999774932861,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.675,0.000,0.738",
                "police2,-1.670,0.000,-4.617,0.000,-0.047,0.000,0.999",
                "security,-2.177,0.000,-4.677,0.000,-0.969,0.000,0.247",
                "observationCamera,-1.296,0.377,-3.862,0.030,-0.938,0.099,0.331"
            ]
        },
        {
            "time": 4.548999786376953,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.680,0.000,0.733",
                "police2,-1.670,0.000,-4.617,0.000,-0.061,0.000,0.998",
                "security,-2.179,0.000,-4.679,0.000,-0.968,0.000,0.249",
                "observationCamera,-1.295,0.377,-3.862,0.030,-0.938,0.099,0.331"
            ]
        },
        {
            "time": 4.564000129699707,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.687,0.000,0.727",
                "police2,-1.670,0.000,-4.617,0.000,-0.077,0.000,0.997",
                "security,-2.182,0.000,-4.682,0.000,-0.968,0.000,0.252",
                "observationCamera,-1.295,0.377,-3.861,0.030,-0.938,0.099,0.331"
            ]
        },
        {
            "time": 4.577000141143799,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.694,0.000,0.720",
                "police2,-1.670,0.000,-4.617,0.000,-0.095,0.000,0.996",
                "security,-2.185,0.000,-4.685,0.000,-0.967,0.000,0.255",
                "observationCamera,-1.295,0.377,-3.861,0.030,-0.938,0.099,0.331"
            ]
        },
        {
            "time": 4.5920000076293949,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.699,0.000,0.715",
                "police2,-1.670,0.000,-4.617,0.000,-0.109,0.000,0.994",
                "security,-2.187,0.000,-4.687,0.000,-0.966,0.000,0.257",
                "observationCamera,-1.295,0.377,-3.861,0.030,-0.938,0.099,0.330"
            ]
        },
        {
            "time": 4.599999904632568,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.706,0.000,0.708",
                "police2,-1.670,0.000,-4.617,0.000,-0.127,0.000,0.992",
                "security,-2.190,0.000,-4.690,0.000,-0.966,0.000,0.260",
                "observationCamera,-1.295,0.377,-3.860,0.030,-0.938,0.098,0.330"
            ]
        },
        {
            "time": 4.61299991607666,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.710,0.000,0.705",
                "police2,-1.670,0.000,-4.617,0.000,-0.136,0.000,0.991",
                "security,-2.192,0.000,-4.692,0.000,-0.965,0.000,0.261",
                "observationCamera,-1.294,0.377,-3.860,0.030,-0.938,0.098,0.330"
            ]
        },
        {
            "time": 4.625999927520752,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.715,0.000,0.699",
                "police2,-1.670,0.000,-4.617,0.000,-0.152,0.000,0.988",
                "security,-2.194,0.000,-4.694,0.000,-0.965,0.000,0.264",
                "observationCamera,-1.294,0.377,-3.859,0.030,-0.938,0.098,0.330"
            ]
        },
        {
            "time": 4.639999866485596,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.721,0.000,0.693",
                "police2,-1.670,0.000,-4.617,0.000,-0.167,0.000,0.986",
                "security,-2.197,0.000,-4.697,0.000,-0.964,0.000,0.266",
                "observationCamera,-1.294,0.378,-3.859,0.030,-0.938,0.098,0.330"
            ]
        },
        {
            "time": 4.6519999504089359,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.726,0.000,0.687",
                "police2,-1.670,0.000,-4.617,0.000,-0.181,0.000,0.983",
                "security,-2.199,0.000,-4.699,0.000,-0.963,0.000,0.268",
                "observationCamera,-1.294,0.378,-3.859,0.030,-0.939,0.098,0.330"
            ]
        },
        {
            "time": 4.663000106811523,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.731,0.000,0.682",
                "police2,-1.670,0.000,-4.617,0.000,-0.195,0.000,0.981",
                "security,-2.201,0.000,-4.701,0.000,-0.963,0.000,0.270",
                "observationCamera,-1.294,0.378,-3.858,0.030,-0.939,0.098,0.330"
            ]
        },
        {
            "time": 4.675000190734863,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.735,0.000,0.678",
                "police2,-1.670,0.000,-4.617,0.000,-0.207,0.000,0.978",
                "security,-2.203,0.000,-4.703,0.000,-0.962,0.000,0.272",
                "observationCamera,-1.294,0.378,-3.858,0.030,-0.939,0.098,0.329"
            ]
        },
        {
            "time": 4.688000202178955,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.740,0.000,0.673",
                "police2,-1.670,0.000,-4.617,0.000,-0.220,0.000,0.976",
                "security,-2.205,0.000,-4.705,0.000,-0.962,0.000,0.274",
                "observationCamera,-1.293,0.378,-3.858,0.030,-0.939,0.098,0.329"
            ]
        },
        {
            "time": 4.704999923706055,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.745,0.000,0.667",
                "police2,-1.670,0.000,-4.617,0.000,-0.233,0.000,0.972",
                "security,-2.207,0.000,-4.707,0.000,-0.961,0.000,0.276",
                "observationCamera,-1.293,0.378,-3.857,0.030,-0.939,0.098,0.329"
            ]
        },
        {
            "time": 4.7170000076293949,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.751,0.000,0.661",
                "police2,-1.670,0.000,-4.617,0.000,-0.250,0.000,0.968",
                "security,-2.210,0.000,-4.710,0.000,-0.960,0.000,0.279",
                "observationCamera,-1.293,0.378,-3.857,0.030,-0.939,0.097,0.329"
            ]
        },
        {
            "time": 4.724999904632568,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.755,0.000,0.656",
                "police2,-1.670,0.000,-4.617,0.000,-0.262,0.000,0.965",
                "security,-2.212,0.000,-4.712,0.000,-0.960,0.000,0.280",
                "observationCamera,-1.293,0.378,-3.856,0.029,-0.939,0.097,0.329"
            ]
        },
        {
            "time": 4.736999988555908,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.757,0.000,0.653",
                "police2,-1.670,0.000,-4.617,0.000,-0.269,0.000,0.963",
                "security,-2.213,0.000,-4.713,0.000,-0.960,0.000,0.281",
                "observationCamera,-1.293,0.378,-3.856,0.029,-0.939,0.097,0.329"
            ]
        },
        {
            "time": 4.75,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.761,0.000,0.649",
                "police2,-1.670,0.000,-4.617,0.000,-0.280,0.000,0.960",
                "security,-2.214,0.000,-4.714,0.000,-0.959,0.000,0.283",
                "observationCamera,-1.293,0.378,-3.856,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.763000011444092,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.765,0.000,0.644",
                "police2,-1.670,0.000,-4.617,0.000,-0.291,0.000,0.957",
                "security,-2.216,0.000,-4.716,0.000,-0.959,0.000,0.285",
                "observationCamera,-1.292,0.378,-3.855,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.7769999504089359,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.768,0.000,0.640",
                "police2,-1.670,0.000,-4.617,0.000,-0.303,0.000,0.953",
                "security,-2.218,0.000,-4.718,0.000,-0.958,0.000,0.286",
                "observationCamera,-1.292,0.378,-3.855,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.789000034332275,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.772,0.000,0.635",
                "police2,-1.670,0.000,-4.617,0.000,-0.315,0.000,0.949",
                "security,-2.219,0.000,-4.719,0.000,-0.958,0.000,0.288",
                "observationCamera,-1.292,0.378,-3.854,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.802000045776367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.775,0.000,0.631",
                "police2,-1.670,0.000,-4.617,0.000,-0.324,0.000,0.946",
                "security,-2.221,0.000,-4.721,0.000,-0.957,0.000,0.289",
                "observationCamera,-1.292,0.378,-3.854,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.815999984741211,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.778,0.000,0.628",
                "police2,-1.670,0.000,-4.617,0.000,-0.333,0.000,0.943",
                "security,-2.222,0.000,-4.722,0.000,-0.957,0.000,0.290",
                "observationCamera,-1.292,0.378,-3.854,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.824999809265137,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.782,0.000,0.624",
                "police2,-1.670,0.000,-4.617,0.000,-0.344,0.000,0.939",
                "security,-2.224,0.000,-4.724,0.000,-0.956,0.000,0.292",
                "observationCamera,-1.291,0.378,-3.853,0.029,-0.939,0.097,0.328"
            ]
        },
        {
            "time": 4.839000225067139,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.784,0.000,0.621",
                "police2,-1.670,0.000,-4.617,0.000,-0.350,0.000,0.937",
                "security,-2.224,0.000,-4.724,0.000,-0.956,0.000,0.293",
                "observationCamera,-1.291,0.378,-3.853,0.029,-0.939,0.096,0.327"
            ]
        },
        {
            "time": 4.8520002365112309,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.787,0.000,0.618",
                "police2,-1.670,0.000,-4.617,0.000,-0.358,0.000,0.934",
                "security,-2.226,0.000,-4.726,0.000,-0.956,0.000,0.294",
                "observationCamera,-1.291,0.378,-3.853,0.029,-0.940,0.096,0.327"
            ]
        },
        {
            "time": 4.864999771118164,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.789,0.000,0.614",
                "police2,-1.670,0.000,-4.617,0.000,-0.366,0.000,0.931",
                "security,-2.227,0.000,-4.727,0.000,-0.956,0.000,0.295",
                "observationCamera,-1.291,0.378,-3.852,0.029,-0.940,0.096,0.327"
            ]
        },
        {
            "time": 4.876999855041504,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.791,0.000,0.611",
                "police2,-1.670,0.000,-4.617,0.000,-0.373,0.000,0.928",
                "security,-2.228,0.000,-4.728,0.000,-0.955,0.000,0.296",
                "observationCamera,-1.291,0.378,-3.852,0.029,-0.940,0.096,0.327"
            ]
        },
        {
            "time": 4.889999866485596,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.793,0.000,0.609",
                "police2,-1.670,0.000,-4.617,0.000,-0.379,0.000,0.925",
                "security,-2.229,0.000,-4.729,0.000,-0.955,0.000,0.297",
                "observationCamera,-1.291,0.378,-3.851,0.029,-0.940,0.096,0.327"
            ]
        },
        {
            "time": 4.9029998779296879,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.795,0.000,0.606",
                "police2,-1.670,0.000,-4.617,0.000,-0.386,0.000,0.923",
                "security,-2.230,0.000,-4.730,0.000,-0.955,0.000,0.297",
                "observationCamera,-1.290,0.378,-3.851,0.029,-0.940,0.096,0.327"
            ]
        },
        {
            "time": 4.916999816894531,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.797,0.000,0.604",
                "police2,-1.670,0.000,-4.617,0.000,-0.391,0.000,0.920",
                "security,-2.230,0.000,-4.730,0.000,-0.955,0.000,0.298",
                "observationCamera,-1.290,0.378,-3.851,0.029,-0.940,0.096,0.326"
            ]
        },
        {
            "time": 4.926000118255615,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.798,0.000,0.602",
                "police2,-1.670,0.000,-4.617,0.000,-0.396,0.000,0.918",
                "security,-2.231,0.000,-4.731,0.000,-0.954,0.000,0.299",
                "observationCamera,-1.290,0.378,-3.850,0.029,-0.940,0.096,0.326"
            ]
        },
        {
            "time": 4.936999797821045,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.799,0.000,0.601",
                "police2,-1.670,0.000,-4.617,0.000,-0.399,0.000,0.917",
                "security,-2.231,0.000,-4.731,0.000,-0.954,0.000,0.299",
                "observationCamera,-1.290,0.378,-3.850,0.029,-0.940,0.096,0.326"
            ]
        },
        {
            "time": 4.949999809265137,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.800,0.000,0.600",
                "police2,-1.670,0.000,-4.617,0.000,-0.402,0.000,0.916",
                "security,-2.232,0.000,-4.732,0.000,-0.954,0.000,0.300",
                "observationCamera,-1.290,0.378,-3.850,0.029,-0.940,0.096,0.326"
            ]
        },
        {
            "time": 4.965000152587891,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.801,0.000,0.598",
                "police2,-1.670,0.000,-4.617,0.000,-0.405,0.000,0.914",
                "security,-2.232,0.000,-4.732,0.000,-0.954,0.000,0.300",
                "observationCamera,-1.290,0.378,-3.849,0.028,-0.940,0.095,0.326"
            ]
        },
        {
            "time": 4.979000091552734,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.802,0.000,0.597",
                "police2,-1.670,0.000,-4.617,0.000,-0.408,0.000,0.913",
                "security,-2.233,0.000,-4.733,0.000,-0.954,0.000,0.300",
                "observationCamera,-1.289,0.378,-3.849,0.028,-0.940,0.095,0.326"
            ]
        },
        {
            "time": 4.988999843597412,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.803,0.000,0.597",
                "police2,-1.670,0.000,-4.617,0.000,-0.410,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.954,0.000,0.301",
                "observationCamera,-1.289,0.378,-3.848,0.028,-0.940,0.095,0.326"
            ]
        },
        {
            "time": 5.000999927520752,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.803,0.000,0.596",
                "police2,-1.670,0.000,-4.617,0.000,-0.410,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.954,0.000,0.301",
                "observationCamera,-1.289,0.378,-3.848,0.028,-0.940,0.095,0.325"
            ]
        },
        {
            "time": 5.013999938964844,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.803,0.000,0.596",
                "police2,-1.670,0.000,-4.617,0.000,-0.411,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.954,0.000,0.301",
                "observationCamera,-1.289,0.378,-3.848,0.028,-0.940,0.095,0.325"
            ]
        },
        {
            "time": 5.0269999504089359,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.803,0.000,0.596",
                "police2,-1.670,0.000,-4.617,0.000,-0.411,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.954,0.000,0.300",
                "observationCamera,-1.289,0.378,-3.847,0.028,-0.940,0.095,0.325"
            ]
        },
        {
            "time": 5.039000034332275,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.803,0.000,0.596",
                "police2,-1.670,0.000,-4.617,0.000,-0.410,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.955,0.000,0.298",
                "observationCamera,-1.289,0.378,-3.847,0.028,-0.941,0.095,0.325"
            ]
        },
        {
            "time": 5.050000190734863,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.802,0.000,0.597",
                "police2,-1.670,0.000,-4.617,0.000,-0.410,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.956,0.000,0.294",
                "observationCamera,-1.288,0.378,-3.846,0.028,-0.941,0.095,0.325"
            ]
        },
        {
            "time": 5.065000057220459,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.802,0.000,0.597",
                "police2,-1.670,0.000,-4.617,0.000,-0.409,0.000,0.912",
                "security,-2.233,0.000,-4.733,0.000,-0.957,0.000,0.291",
                "observationCamera,-1.288,0.378,-3.846,0.028,-0.941,0.095,0.325"
            ]
        },
        {
            "time": 5.077000141143799,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.802,0.000,0.598",
                "police2,-1.670,0.000,-4.617,0.000,-0.408,0.000,0.913",
                "security,-2.233,0.000,-4.733,0.000,-0.959,0.000,0.284",
                "observationCamera,-1.288,0.378,-3.846,0.028,-0.941,0.094,0.325"
            ]
        },
        {
            "time": 5.089000225067139,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.801,0.000,0.598",
                "police2,-1.670,0.000,-4.617,0.000,-0.407,0.000,0.913",
                "security,-2.233,0.000,-4.733,0.000,-0.961,0.000,0.276",
                "observationCamera,-1.288,0.378,-3.845,0.028,-0.941,0.094,0.324"
            ]
        },
        {
            "time": 5.10099983215332,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.801,0.000,0.599",
                "police2,-1.670,0.000,-4.617,0.000,-0.406,0.000,0.914",
                "security,-2.233,0.000,-4.733,0.000,-0.963,0.000,0.269",
                "observationCamera,-1.288,0.378,-3.845,0.028,-0.941,0.094,0.324"
            ]
        },
        {
            "time": 5.116000175476074,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.800,0.000,0.599",
                "police2,-1.670,0.000,-4.617,0.000,-0.405,0.000,0.914",
                "security,-2.233,0.000,-4.733,0.000,-0.966,0.000,0.260",
                "observationCamera,-1.288,0.378,-3.844,0.028,-0.941,0.094,0.324"
            ]
        },
        {
            "time": 5.129000186920166,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.800,0.000,0.600",
                "police2,-1.670,0.000,-4.617,0.000,-0.404,0.000,0.915",
                "security,-2.233,0.000,-4.733,0.000,-0.969,0.000,0.248",
                "observationCamera,-1.287,0.378,-3.844,0.028,-0.941,0.094,0.324"
            ]
        },
        {
            "time": 5.138999938964844,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.799,0.000,0.601",
                "police2,-1.670,0.000,-4.617,0.000,-0.402,0.000,0.916",
                "security,-2.233,0.000,-4.733,0.000,-0.972,0.000,0.235",
                "observationCamera,-1.287,0.378,-3.844,0.028,-0.941,0.094,0.324"
            ]
        },
        {
            "time": 5.14900016784668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.798,0.000,0.602",
                "police2,-1.670,0.000,-4.617,0.000,-0.401,0.000,0.916",
                "security,-2.233,0.000,-4.733,0.000,-0.974,0.000,0.226",
                "observationCamera,-1.287,0.378,-3.843,0.028,-0.941,0.094,0.324"
            ]
        },
        {
            "time": 5.164999961853027,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.798,0.000,0.603",
                "police2,-1.670,0.000,-4.617,0.000,-0.399,0.000,0.917",
                "security,-2.233,0.000,-4.733,0.000,-0.977,0.000,0.214",
                "observationCamera,-1.287,0.378,-3.843,0.028,-0.941,0.094,0.323"
            ]
        },
        {
            "time": 5.177999973297119,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.797,0.000,0.605",
                "police2,-1.670,0.000,-4.617,0.000,-0.396,0.000,0.918",
                "security,-2.233,0.000,-4.733,0.000,-0.981,0.000,0.196",
                "observationCamera,-1.287,0.378,-3.843,0.028,-0.941,0.094,0.323"
            ]
        },
        {
            "time": 5.190999984741211,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.796,0.000,0.606",
                "police2,-1.670,0.000,-4.617,0.000,-0.394,0.000,0.919",
                "security,-2.233,0.000,-4.733,0.000,-0.984,0.000,0.181",
                "observationCamera,-1.287,0.378,-3.842,0.028,-0.941,0.094,0.323"
            ]
        },
        {
            "time": 5.201000213623047,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.794,0.000,0.607",
                "police2,-1.670,0.000,-4.617,0.000,-0.392,0.000,0.920",
                "security,-2.233,0.000,-4.733,0.000,-0.987,0.000,0.163",
                "observationCamera,-1.286,0.378,-3.842,0.027,-0.941,0.093,0.323"
            ]
        },
        {
            "time": 5.214000225067139,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.794,0.000,0.609",
                "police2,-1.670,0.000,-4.617,0.000,-0.390,0.000,0.921",
                "security,-2.233,0.000,-4.733,0.000,-0.989,0.000,0.149",
                "observationCamera,-1.286,0.378,-3.841,0.027,-0.941,0.093,0.323"
            ]
        },
        {
            "time": 5.229000091552734,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.792,0.000,0.610",
                "police2,-1.670,0.000,-4.617,0.000,-0.387,0.000,0.922",
                "security,-2.233,0.000,-4.733,0.000,-0.992,0.000,0.130",
                "observationCamera,-1.286,0.378,-3.841,0.027,-0.942,0.093,0.323"
            ]
        },
        {
            "time": 5.238999843597412,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.791,0.000,0.612",
                "police2,-1.670,0.000,-4.617,0.000,-0.384,0.000,0.923",
                "security,-2.233,0.000,-4.733,0.000,-0.994,0.000,0.108",
                "observationCamera,-1.286,0.378,-3.841,0.027,-0.942,0.093,0.323"
            ]
        },
        {
            "time": 5.250999927520752,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.790,0.000,0.613",
                "police2,-1.670,0.000,-4.617,0.000,-0.381,0.000,0.925",
                "security,-2.233,0.000,-4.733,0.000,-0.996,0.000,0.091",
                "observationCamera,-1.286,0.379,-3.840,0.027,-0.942,0.093,0.322"
            ]
        },
        {
            "time": 5.265999794006348,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.789,0.000,0.615",
                "police2,-1.670,0.000,-4.617,0.000,-0.378,0.000,0.926",
                "security,-2.233,0.000,-4.733,0.000,-0.997,0.000,0.072",
                "observationCamera,-1.285,0.379,-3.840,0.027,-0.942,0.093,0.322"
            ]
        },
        {
            "time": 5.2769999504089359,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.787,0.000,0.617",
                "police2,-1.670,0.000,-4.617,0.000,-0.375,0.000,0.927",
                "security,-2.233,0.000,-4.733,0.000,-0.999,0.000,0.046",
                "observationCamera,-1.285,0.379,-3.839,0.027,-0.942,0.093,0.322"
            ]
        },
        {
            "time": 5.293000221252441,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.786,0.000,0.619",
                "police2,-1.670,0.000,-4.617,0.000,-0.372,0.000,0.928",
                "security,-2.233,0.000,-4.733,0.000,-1.000,0.000,0.026",
                "observationCamera,-1.285,0.379,-3.839,0.027,-0.942,0.093,0.322"
            ]
        },
        {
            "time": 5.304999828338623,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.784,0.000,0.621",
                "police2,-1.670,0.000,-4.617,0.000,-0.367,0.000,0.930",
                "security,-2.233,0.000,-4.733,0.000,-1.000,0.000,-0.002",
                "observationCamera,-1.285,0.379,-3.839,0.027,-0.942,0.093,0.322"
            ]
        },
        {
            "time": 5.316999912261963,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.782,0.000,0.623",
                "police2,-1.670,0.000,-4.617,0.000,-0.364,0.000,0.931",
                "security,-2.233,0.000,-4.733,0.000,-1.000,0.000,-0.024",
                "observationCamera,-1.285,0.379,-3.838,0.027,-0.942,0.092,0.322"
            ]
        },
        {
            "time": 5.328999996185303,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.781,0.000,0.625",
                "police2,-1.670,0.000,-4.617,0.000,-0.360,0.000,0.933",
                "security,-2.233,0.000,-4.733,0.000,-0.999,0.000,-0.047",
                "observationCamera,-1.285,0.379,-3.838,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.3420000076293949,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.779,0.000,0.627",
                "police2,-1.670,0.000,-4.617,0.000,-0.356,0.000,0.934",
                "security,-2.233,0.000,-4.733,0.000,-0.998,0.000,-0.071",
                "observationCamera,-1.284,0.379,-3.838,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.354000091552734,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.777,0.000,0.629",
                "police2,-1.670,0.000,-4.617,0.000,-0.352,0.000,0.936",
                "security,-2.233,0.000,-4.733,0.000,-0.995,0.000,-0.096",
                "observationCamera,-1.284,0.379,-3.837,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.366000175476074,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.775,0.000,0.632",
                "police2,-1.670,0.000,-4.617,0.000,-0.348,0.000,0.937",
                "security,-2.233,0.000,-4.733,0.000,-0.993,0.000,-0.121",
                "observationCamera,-1.284,0.379,-3.837,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.379000186920166,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.773,0.000,0.634",
                "police2,-1.670,0.000,-4.617,0.000,-0.344,0.000,0.939",
                "security,-2.233,0.000,-4.733,0.000,-0.990,0.000,-0.144",
                "observationCamera,-1.284,0.379,-3.836,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.394000053405762,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.771,0.000,0.636",
                "police2,-1.670,0.000,-4.617,0.000,-0.340,0.000,0.940",
                "security,-2.233,0.000,-4.733,0.000,-0.985,0.000,-0.171",
                "observationCamera,-1.284,0.379,-3.836,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.40500020980835,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.769,0.000,0.639",
                "police2,-1.670,0.000,-4.617,0.000,-0.335,0.000,0.942",
                "security,-2.233,0.000,-4.733,0.000,-0.979,0.000,-0.202",
                "observationCamera,-1.284,0.379,-3.836,0.027,-0.942,0.092,0.321"
            ]
        },
        {
            "time": 5.416999816894531,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.767,0.000,0.641",
                "police2,-1.670,0.000,-4.617,0.000,-0.330,0.000,0.944",
                "security,-2.233,0.000,-4.733,0.000,-0.974,0.000,-0.225",
                "observationCamera,-1.283,0.379,-3.835,0.027,-0.942,0.092,0.320"
            ]
        },
        {
            "time": 5.429999828338623,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.765,0.000,0.644",
                "police2,-1.670,0.000,-4.617,0.000,-0.326,0.000,0.945",
                "security,-2.233,0.000,-4.733,0.000,-0.968,0.000,-0.251",
                "observationCamera,-1.283,0.379,-3.835,0.027,-0.943,0.092,0.320"
            ]
        },
        {
            "time": 5.442999839782715,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.763,0.000,0.647",
                "police2,-1.670,0.000,-4.617,0.000,-0.321,0.000,0.947",
                "security,-2.233,0.000,-4.733,0.000,-0.960,0.000,-0.278",
                "observationCamera,-1.283,0.379,-3.834,0.026,-0.943,0.091,0.320"
            ]
        },
        {
            "time": 5.459000110626221,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.761,0.000,0.649",
                "police2,-1.670,0.000,-4.617,0.000,-0.316,0.000,0.949",
                "security,-2.233,0.000,-4.733,0.000,-0.953,0.000,-0.304",
                "observationCamera,-1.283,0.379,-3.834,0.026,-0.943,0.091,0.320"
            ]
        },
        {
            "time": 5.466000080108643,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.757,0.000,0.653",
                "police2,-1.670,0.000,-4.617,0.000,-0.309,0.000,0.951",
                "security,-2.233,0.000,-4.733,0.000,-0.941,0.000,-0.339",
                "observationCamera,-1.283,0.379,-3.834,0.026,-0.943,0.091,0.320"
            ]
        },
        {
            "time": 5.479000091552734,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.756,0.000,0.654",
                "police2,-1.670,0.000,-4.617,0.000,-0.306,0.000,0.952",
                "security,-2.233,0.000,-4.733,0.000,-0.936,0.000,-0.353",
                "observationCamera,-1.283,0.379,-3.833,0.026,-0.943,0.091,0.320"
            ]
        },
        {
            "time": 5.49399995803833,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.754,0.000,0.657",
                "police2,-1.670,0.000,-4.617,0.000,-0.301,0.000,0.954",
                "security,-2.233,0.000,-4.733,0.000,-0.925,0.000,-0.379",
                "observationCamera,-1.282,0.379,-3.833,0.026,-0.943,0.091,0.319"
            ]
        },
        {
            "time": 5.505000114440918,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.751,0.000,0.661",
                "police2,-1.670,0.000,-4.617,0.000,-0.295,0.000,0.956",
                "security,-2.233,0.000,-4.733,0.000,-0.912,0.000,-0.410",
                "observationCamera,-1.282,0.379,-3.832,0.026,-0.943,0.091,0.319"
            ]
        },
        {
            "time": 5.51800012588501,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.749,0.000,0.663",
                "police2,-1.670,0.000,-4.617,0.000,-0.290,0.000,0.957",
                "security,-2.233,0.000,-4.733,0.000,-0.902,0.000,-0.432",
                "observationCamera,-1.282,0.379,-3.832,0.026,-0.943,0.091,0.319"
            ]
        },
        {
            "time": 5.531000137329102,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.746,0.000,0.666",
                "police2,-1.670,0.000,-4.617,0.000,-0.284,0.000,0.959",
                "security,-2.233,0.000,-4.733,0.000,-0.889,0.000,-0.459",
                "observationCamera,-1.282,0.379,-3.832,0.026,-0.943,0.091,0.319"
            ]
        },
        {
            "time": 5.547999858856201,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.743,0.000,0.669",
                "police2,-1.670,0.000,-4.617,0.000,-0.278,0.000,0.961",
                "security,-2.233,0.000,-4.733,0.000,-0.875,0.000,-0.485",
                "observationCamera,-1.282,0.379,-3.831,0.026,-0.943,0.091,0.319"
            ]
        },
        {
            "time": 5.559999942779541,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.739,0.000,0.673",
                "police2,-1.670,0.000,-4.617,0.000,-0.270,0.000,0.963",
                "security,-2.233,0.000,-4.733,0.000,-0.856,0.000,-0.516",
                "observationCamera,-1.281,0.379,-3.831,0.026,-0.943,0.090,0.319"
            ]
        },
        {
            "time": 5.567999839782715,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.737,0.000,0.676",
                "police2,-1.670,0.000,-4.617,0.000,-0.264,0.000,0.964",
                "security,-2.233,0.000,-4.733,0.000,-0.842,0.000,-0.539",
                "observationCamera,-1.281,0.379,-3.830,0.026,-0.943,0.090,0.318"
            ]
        },
        {
            "time": 5.583000183105469,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.735,0.000,0.678",
                "police2,-1.670,0.000,-4.617,0.000,-0.261,0.000,0.965",
                "security,-2.233,0.000,-4.733,0.000,-0.833,0.000,-0.553",
                "observationCamera,-1.281,0.379,-3.830,0.026,-0.943,0.090,0.318"
            ]
        },
        {
            "time": 5.593999862670898,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.732,0.000,0.682",
                "police2,-1.670,0.000,-4.617,0.000,-0.254,0.000,0.967",
                "security,-2.233,0.000,-4.733,0.000,-0.815,0.000,-0.580",
                "observationCamera,-1.281,0.379,-3.830,0.026,-0.943,0.090,0.318"
            ]
        },
        {
            "time": 5.609000205993652,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.729,0.000,0.684",
                "police2,-1.670,0.000,-4.617,0.000,-0.248,0.000,0.969",
                "security,-2.233,0.000,-4.733,0.000,-0.801,0.000,-0.599",
                "observationCamera,-1.281,0.379,-3.829,0.026,-0.943,0.090,0.318"
            ]
        },
        {
            "time": 5.623000144958496,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.726,0.000,0.688",
                "police2,-1.670,0.000,-4.617,0.000,-0.241,0.000,0.971",
                "security,-2.233,0.000,-4.733,0.000,-0.781,0.000,-0.625",
                "observationCamera,-1.281,0.379,-3.829,0.026,-0.944,0.090,0.318"
            ]
        },
        {
            "time": 5.632999897003174,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.722,0.000,0.692",
                "police2,-1.670,0.000,-4.617,0.000,-0.234,0.000,0.972",
                "security,-2.233,0.000,-4.733,0.000,-0.762,0.000,-0.647",
                "observationCamera,-1.280,0.379,-3.828,0.026,-0.944,0.090,0.318"
            ]
        },
        {
            "time": 5.645999908447266,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.720,0.000,0.694",
                "police2,-1.670,0.000,-4.617,0.000,-0.228,0.000,0.974",
                "security,-2.233,0.000,-4.733,0.000,-0.748,0.000,-0.664",
                "observationCamera,-1.280,0.379,-3.828,0.026,-0.944,0.090,0.318"
            ]
        },
        {
            "time": 5.6579999923706059,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.717,0.000,0.697",
                "police2,-1.670,0.000,-4.617,0.000,-0.222,0.000,0.975",
                "security,-2.233,0.000,-4.733,0.000,-0.730,0.000,-0.683",
                "observationCamera,-1.280,0.379,-3.828,0.026,-0.944,0.090,0.317"
            ]
        },
        {
            "time": 5.670000076293945,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.714,0.000,0.701",
                "police2,-1.670,0.000,-4.617,0.000,-0.215,0.000,0.977",
                "security,-2.233,0.000,-4.733,0.000,-0.713,0.000,-0.701",
                "observationCamera,-1.280,0.379,-3.827,0.026,-0.944,0.090,0.317"
            ]
        },
        {
            "time": 5.683000087738037,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.711,0.000,0.704",
                "police2,-1.670,0.000,-4.617,0.000,-0.209,0.000,0.978",
                "security,-2.233,0.000,-4.733,0.000,-0.697,0.000,-0.717",
                "observationCamera,-1.280,0.379,-3.827,0.025,-0.944,0.089,0.317"
            ]
        },
        {
            "time": 5.696000099182129,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.707,0.000,0.707",
                "police2,-1.670,0.000,-4.617,0.000,-0.202,0.000,0.979",
                "security,-2.233,0.000,-4.733,0.000,-0.679,0.000,-0.734",
                "observationCamera,-1.280,0.379,-3.827,0.025,-0.944,0.089,0.317"
            ]
        },
        {
            "time": 5.709000110626221,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.704,0.000,0.710",
                "police2,-1.670,0.000,-4.617,0.000,-0.195,0.000,0.981",
                "security,-2.233,0.000,-4.733,0.000,-0.660,0.000,-0.751",
                "observationCamera,-1.279,0.379,-3.826,0.025,-0.944,0.089,0.317"
            ]
        },
        {
            "time": 5.7220001220703129,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.700,0.000,0.714",
                "police2,-1.670,0.000,-4.617,0.000,-0.188,0.000,0.982",
                "security,-2.233,0.000,-4.733,0.000,-0.641,0.000,-0.767",
                "observationCamera,-1.279,0.379,-3.826,0.025,-0.944,0.089,0.317"
            ]
        },
        {
            "time": 5.734000205993652,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.697,0.000,0.717",
                "police2,-1.670,0.000,-4.617,0.000,-0.181,0.000,0.984",
                "security,-2.233,0.000,-4.733,0.000,-0.624,0.000,-0.782",
                "observationCamera,-1.279,0.379,-3.825,0.025,-0.944,0.089,0.316"
            ]
        },
        {
            "time": 5.747000217437744,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.694,0.000,0.720",
                "police2,-1.670,0.000,-4.617,0.000,-0.174,0.000,0.985",
                "security,-2.233,0.000,-4.733,0.000,-0.607,0.000,-0.795",
                "observationCamera,-1.279,0.379,-3.825,0.025,-0.944,0.089,0.316"
            ]
        },
        {
            "time": 5.760000228881836,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.690,0.000,0.724",
                "police2,-1.670,0.000,-4.617,0.000,-0.167,0.000,0.986",
                "security,-2.233,0.000,-4.733,0.000,-0.589,0.000,-0.808",
                "observationCamera,-1.279,0.379,-3.825,0.025,-0.944,0.089,0.316"
            ]
        },
        {
            "time": 5.771999835968018,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.687,0.000,0.727",
                "police2,-1.670,0.000,-4.617,0.000,-0.160,0.000,0.987",
                "security,-2.233,0.000,-4.733,0.000,-0.572,0.000,-0.820",
                "observationCamera,-1.278,0.379,-3.824,0.025,-0.944,0.089,0.316"
            ]
        },
        {
            "time": 5.7820000648498539,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.683,0.000,0.730",
                "police2,-1.670,0.000,-4.617,0.000,-0.152,0.000,0.988",
                "security,-2.233,0.000,-4.733,0.000,-0.555,0.000,-0.832",
                "observationCamera,-1.278,0.379,-3.824,0.025,-0.944,0.089,0.316"
            ]
        },
        {
            "time": 5.795000076293945,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.680,0.000,0.733",
                "police2,-1.670,0.000,-4.617,0.000,-0.147,0.000,0.989",
                "security,-2.233,0.000,-4.733,0.000,-0.542,0.000,-0.840",
                "observationCamera,-1.278,0.379,-3.824,0.025,-0.944,0.089,0.316"
            ]
        },
        {
            "time": 5.808000087738037,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.677,0.000,0.736",
                "police2,-1.670,0.000,-4.617,0.000,-0.139,0.000,0.990",
                "security,-2.233,0.000,-4.733,0.000,-0.526,0.000,-0.851",
                "observationCamera,-1.278,0.379,-3.823,0.025,-0.944,0.088,0.316"
            ]
        },
        {
            "time": 5.821000099182129,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.673,0.000,0.740",
                "police2,-1.670,0.000,-4.617,0.000,-0.132,0.000,0.991",
                "security,-2.233,0.000,-4.733,0.000,-0.510,0.000,-0.860",
                "observationCamera,-1.278,0.379,-3.823,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.835000038146973,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.669,0.000,0.743",
                "police2,-1.670,0.000,-4.617,0.000,-0.124,0.000,0.992",
                "security,-2.233,0.000,-4.733,0.000,-0.495,0.000,-0.869",
                "observationCamera,-1.278,0.379,-3.822,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.8480000495910648,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.665,0.000,0.747",
                "police2,-1.670,0.000,-4.617,0.000,-0.116,0.000,0.993",
                "security,-2.233,0.000,-4.733,0.000,-0.480,0.000,-0.877",
                "observationCamera,-1.277,0.379,-3.822,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.860000133514404,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.661,0.000,0.750",
                "police2,-1.670,0.000,-4.617,0.000,-0.109,0.000,0.994",
                "security,-2.233,0.000,-4.733,0.000,-0.467,0.000,-0.885",
                "observationCamera,-1.277,0.380,-3.822,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.876999855041504,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.657,0.000,0.754",
                "police2,-1.670,0.000,-4.617,0.000,-0.101,0.000,0.995",
                "security,-2.233,0.000,-4.733,0.000,-0.454,0.000,-0.891",
                "observationCamera,-1.277,0.380,-3.821,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.882999897003174,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.653,0.000,0.758",
                "police2,-1.670,0.000,-4.617,0.000,-0.091,0.000,0.996",
                "security,-2.233,0.000,-4.733,0.000,-0.439,0.000,-0.898",
                "observationCamera,-1.277,0.380,-3.821,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.895999908447266,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.651,0.000,0.759",
                "police2,-1.670,0.000,-4.617,0.000,-0.087,0.000,0.996",
                "security,-2.233,0.000,-4.733,0.000,-0.434,0.000,-0.901",
                "observationCamera,-1.277,0.380,-3.821,0.025,-0.945,0.088,0.315"
            ]
        },
        {
            "time": 5.908999919891357,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.646,0.000,0.763",
                "police2,-1.670,0.000,-4.617,0.000,-0.079,0.000,0.997",
                "security,-2.233,0.000,-4.733,0.000,-0.423,0.000,-0.906",
                "observationCamera,-1.277,0.380,-3.820,0.025,-0.945,0.088,0.314"
            ]
        },
        {
            "time": 5.922999858856201,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.643,0.000,0.766",
                "police2,-1.670,0.000,-4.617,0.000,-0.072,0.000,0.997",
                "security,-2.233,0.000,-4.733,0.000,-0.414,0.000,-0.910",
                "observationCamera,-1.276,0.380,-3.820,0.025,-0.945,0.087,0.314"
            ]
        },
        {
            "time": 5.935999870300293,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.638,0.000,0.770",
                "police2,-1.670,0.000,-4.617,0.000,-0.064,0.000,0.998",
                "security,-2.233,0.000,-4.733,0.000,-0.406,0.000,-0.914",
                "observationCamera,-1.276,0.380,-3.819,0.024,-0.945,0.087,0.314"
            ]
        },
        {
            "time": 5.948999881744385,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.634,0.000,0.773",
                "police2,-1.670,0.000,-4.617,0.000,-0.055,0.000,0.998",
                "security,-2.233,0.000,-4.733,0.000,-0.399,0.000,-0.917",
                "observationCamera,-1.276,0.380,-3.819,0.024,-0.945,0.087,0.314"
            ]
        },
        {
            "time": 5.960999965667725,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.630,0.000,0.776",
                "police2,-1.670,0.000,-4.617,0.000,-0.048,0.000,0.999",
                "security,-2.233,0.000,-4.733,0.000,-0.393,0.000,-0.920",
                "observationCamera,-1.276,0.380,-3.818,0.024,-0.945,0.087,0.314"
            ]
        },
        {
            "time": 5.9730000495910648,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.626,0.000,0.780",
                "police2,-1.670,0.000,-4.617,0.000,-0.040,0.000,0.999",
                "security,-2.233,0.000,-4.733,0.000,-0.389,0.000,-0.921",
                "observationCamera,-1.276,0.380,-3.818,0.024,-0.945,0.087,0.314"
            ]
        },
        {
            "time": 5.984000205993652,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.622,0.000,0.783",
                "police2,-1.670,0.000,-4.617,0.000,-0.033,0.000,0.999",
                "security,-2.233,0.000,-4.733,0.000,-0.386,0.000,-0.923",
                "observationCamera,-1.276,0.380,-3.818,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 5.998000144958496,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.619,0.000,0.785",
                "police2,-1.670,0.000,-4.617,0.000,-0.026,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.384,0.000,-0.923",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.011000156402588,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.615,0.000,0.789",
                "police2,-1.670,0.000,-4.617,0.000,-0.018,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.02400016784668,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.610,0.000,0.792",
                "police2,-1.670,0.000,-4.617,0.000,-0.010,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.0370001792907719,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.606,0.000,0.795",
                "police2,-1.670,0.000,-4.617,0.000,-0.002,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.050000190734863,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.602,0.000,0.798",
                "police2,-1.670,0.000,-4.617,0.000,0.006,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.061999797821045,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.598,0.000,0.802",
                "police2,-1.670,0.000,-4.617,0.000,0.014,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.078000068664551,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.594,0.000,0.805",
                "police2,-1.670,0.000,-4.617,0.000,0.021,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.085000038146973,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.589,0.000,0.808",
                "police2,-1.670,0.000,-4.617,0.000,0.031,0.000,1.000",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.0980000495910648,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.586,0.000,0.810",
                "police2,-1.670,0.000,-4.617,0.000,0.035,0.000,0.999",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.111000061035156,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.582,0.000,0.813",
                "police2,-1.670,0.000,-4.617,0.000,0.043,0.000,0.999",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.125,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.578,0.000,0.816",
                "police2,-1.670,0.000,-4.617,0.000,0.051,0.000,0.999",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.138000011444092,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.573,0.000,0.819",
                "police2,-1.670,0.000,-4.617,0.000,0.059,0.000,0.998",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.151000022888184,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.569,0.000,0.822",
                "police2,-1.670,0.000,-4.617,0.000,0.067,0.000,0.998",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.166999816894531,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.565,0.000,0.825",
                "police2,-1.670,0.000,-4.617,0.000,0.075,0.000,0.997",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.175000190734863,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.560,0.000,0.829",
                "police2,-1.670,0.000,-4.617,0.000,0.084,0.000,0.996",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.189000129699707,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.557,0.000,0.831",
                "police2,-1.670,0.000,-4.617,0.000,0.089,0.000,0.996",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.199999809265137,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.552,0.000,0.834",
                "police2,-1.670,0.000,-4.617,0.000,0.097,0.000,0.995",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.2129998207092289,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.549,0.000,0.836",
                "police2,-1.670,0.000,-4.617,0.000,0.103,0.000,0.995",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.22599983215332,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.544,0.000,0.839",
                "police2,-1.670,0.000,-4.617,0.000,0.111,0.000,0.994",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.23799991607666,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.540,0.000,0.842",
                "police2,-1.670,0.000,-4.617,0.000,0.119,0.000,0.993",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.252999782562256,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.536,0.000,0.844",
                "police2,-1.670,0.000,-4.617,0.000,0.126,0.000,0.992",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.265999794006348,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.531,0.000,0.847",
                "police2,-1.670,0.000,-4.617,0.000,0.134,0.000,0.991",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.2769999504089359,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.527,0.000,0.850",
                "police2,-1.670,0.000,-4.617,0.000,0.141,0.000,0.990",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.289000034332275,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.524,0.000,0.852",
                "police2,-1.670,0.000,-4.617,0.000,0.147,0.000,0.989",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.303999900817871,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.520,0.000,0.854",
                "police2,-1.670,0.000,-4.617,0.000,0.154,0.000,0.988",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.315000057220459,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.515,0.000,0.857",
                "police2,-1.670,0.000,-4.617,0.000,0.162,0.000,0.987",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.328999996185303,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.512,0.000,0.859",
                "police2,-1.670,0.000,-4.617,0.000,0.168,0.000,0.986",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.3420000076293949,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.507,0.000,0.862",
                "police2,-1.670,0.000,-4.617,0.000,0.176,0.000,0.984",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.355999946594238,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.503,0.000,0.864",
                "police2,-1.670,0.000,-4.617,0.000,0.183,0.000,0.983",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.372000217437744,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.499,0.000,0.867",
                "police2,-1.670,0.000,-4.617,0.000,0.190,0.000,0.982",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.383999824523926,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.494,0.000,0.869",
                "police2,-1.670,0.000,-4.617,0.000,0.199,0.000,0.980",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.394000053405762,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.490,0.000,0.872",
                "police2,-1.670,0.000,-4.617,0.000,0.205,0.000,0.979",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.40500020980835,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.487,0.000,0.873",
                "police2,-1.670,0.000,-4.617,0.000,0.210,0.000,0.978",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.421000003814697,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.484,0.000,0.875",
                "police2,-1.670,0.000,-4.617,0.000,0.215,0.000,0.977",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.431000232696533,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.479,0.000,0.878",
                "police2,-1.670,0.000,-4.617,0.000,0.223,0.000,0.975",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.445000171661377,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.476,0.000,0.879",
                "police2,-1.670,0.000,-4.617,0.000,0.228,0.000,0.974",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.460000038146973,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.473,0.000,0.881",
                "police2,-1.670,0.000,-4.617,0.000,0.235,0.000,0.972",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.4720001220703129,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.468,0.000,0.884",
                "police2,-1.670,0.000,-4.617,0.000,0.242,0.000,0.970",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.48199987411499,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.465,0.000,0.885",
                "police2,-1.670,0.000,-4.617,0.000,0.247,0.000,0.969",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.49399995803833,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.462,0.000,0.887",
                "police2,-1.670,0.000,-4.617,0.000,0.252,0.000,0.968",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.508999824523926,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.459,0.000,0.889",
                "police2,-1.670,0.000,-4.617,0.000,0.257,0.000,0.966",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.519999980926514,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.455,0.000,0.891",
                "police2,-1.670,0.000,-4.617,0.000,0.264,0.000,0.965",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.533999919891357,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.452,0.000,0.892",
                "police2,-1.670,0.000,-4.617,0.000,0.269,0.000,0.963",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.546000003814697,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.448,0.000,0.894",
                "police2,-1.670,0.000,-4.617,0.000,0.275,0.000,0.962",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.559000015258789,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.445,0.000,0.896",
                "police2,-1.670,0.000,-4.617,0.000,0.280,0.000,0.960",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.572000026702881,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.442,0.000,0.897",
                "police2,-1.670,0.000,-4.617,0.000,0.285,0.000,0.959",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.585999965667725,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.438,0.000,0.899",
                "police2,-1.670,0.000,-4.617,0.000,0.290,0.000,0.957",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.5970001220703129,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.435,0.000,0.900",
                "police2,-1.670,0.000,-4.617,0.000,0.295,0.000,0.955",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.610000133514404,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.433,0.000,0.902",
                "police2,-1.670,0.000,-4.617,0.000,0.300,0.000,0.954",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.623000144958496,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.429,0.000,0.903",
                "police2,-1.670,0.000,-4.617,0.000,0.304,0.000,0.953",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.63700008392334,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.426,0.000,0.905",
                "police2,-1.670,0.000,-4.617,0.000,0.309,0.000,0.951",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.650000095367432,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.423,0.000,0.906",
                "police2,-1.670,0.000,-4.617,0.000,0.314,0.000,0.949",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.663000106811523,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.421,0.000,0.907",
                "police2,-1.670,0.000,-4.617,0.000,0.318,0.000,0.948",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.677000045776367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.418,0.000,0.909",
                "police2,-1.670,0.000,-4.617,0.000,0.323,0.000,0.947",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.691999912261963,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.415,0.000,0.910",
                "police2,-1.670,0.000,-4.617,0.000,0.327,0.000,0.945",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.698999881744385,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.412,0.000,0.911",
                "police2,-1.670,0.000,-4.617,0.000,0.332,0.000,0.943",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.7129998207092289,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.411,0.000,0.912",
                "police2,-1.670,0.000,-4.617,0.000,0.334,0.000,0.943",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.72599983215332,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.408,0.000,0.913",
                "police2,-1.670,0.000,-4.617,0.000,0.338,0.000,0.941",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.741000175476074,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.406,0.000,0.914",
                "police2,-1.670,0.000,-4.617,0.000,0.341,0.000,0.940",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.755000114440918,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.403,0.000,0.915",
                "police2,-1.670,0.000,-4.617,0.000,0.345,0.000,0.938",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.765999794006348,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.401,0.000,0.916",
                "police2,-1.670,0.000,-4.617,0.000,0.349,0.000,0.937",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.7820000648498539,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.399,0.000,0.917",
                "police2,-1.670,0.000,-4.617,0.000,0.352,0.000,0.936",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.794000148773193,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.397,0.000,0.918",
                "police2,-1.670,0.000,-4.617,0.000,0.355,0.000,0.935",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.802000045776367,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.395,0.000,0.919",
                "police2,-1.670,0.000,-4.617,0.000,0.358,0.000,0.934",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.816999912261963,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.394,0.000,0.919",
                "police2,-1.670,0.000,-4.617,0.000,0.359,0.000,0.933",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.828000068664551,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.392,0.000,0.920",
                "police2,-1.670,0.000,-4.617,0.000,0.362,0.000,0.932",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.8420000076293949,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.391,0.000,0.921",
                "police2,-1.670,0.000,-4.617,0.000,0.365,0.000,0.931",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.855999946594238,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.389,0.000,0.921",
                "police2,-1.670,0.000,-4.617,0.000,0.367,0.000,0.930",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.868000030517578,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.388,0.000,0.922",
                "police2,-1.670,0.000,-4.617,0.000,0.369,0.000,0.929",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.880000114440918,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.387,0.000,0.922",
                "police2,-1.670,0.000,-4.617,0.000,0.371,0.000,0.929",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.892000198364258,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.385,0.000,0.923",
                "police2,-1.670,0.000,-4.617,0.000,0.372,0.000,0.928",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.9029998779296879,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.384,0.000,0.923",
                "police2,-1.670,0.000,-4.617,0.000,0.374,0.000,0.927",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.916999816894531,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.384,0.000,0.923",
                "police2,-1.670,0.000,-4.617,0.000,0.375,0.000,0.927",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.932000160217285,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.383,0.000,0.924",
                "police2,-1.670,0.000,-4.617,0.000,0.376,0.000,0.926",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.942999839782715,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.382,0.000,0.924",
                "police2,-1.670,0.000,-4.617,0.000,0.378,0.000,0.926",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.955999851226807,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.381,0.000,0.924",
                "police2,-1.670,0.000,-4.617,0.000,0.378,0.000,0.926",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.9679999351501469,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.381,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.379,0.000,0.925",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.980999946594238,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.381,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 6.99399995803833,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.380,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        },
        {
            "time": 7.00600004196167,
            "data": [
                "police1,-1.823,0.000,-4.549,0.000,0.380,0.000,0.925",
                "police2,-1.670,0.000,-4.617,0.000,0.380,0.000,0.925",
                "security,-2.233,0.000,-4.733,0.000,-0.383,0.000,-0.924",
                "observationCamera,-1.275,0.380,-3.817,0.024,-0.945,0.087,0.313"
            ]
        }
    ]
};